export const Href: string = "#javascript";
export const UiKits: string = "Ui Kits";
export const Icons: string = "Icons";
export const Buttons: string = "Buttons";
export const BonusUi: string = "Bonus Ui";
export const Learning: string = "Learning";
export const DataTables: string = "Data Tables";
export const BootstrapTable: string = "Bootstrap Tables";
export const FormControls: string = "Form Controls";
export const Editors: string = "Editors";
export const Knowledgebase: string = "Knowledgebase";
export const Apps: string = "Apps";
export const Page: string = "Pages";
export const JobSearch: string = "Job Search";
export const FormWidgets: string = "Form Widgets";
export const Maps: string = "Maps";
export const Charts: string = "Charts";
export const Widget: string = "Widgets";
export const Ecommerce: string = "Ecommerce";
export const Email: string = "Email";
export const Project: string = "Project";
export const Chat: string = "Chat";
export const Dashboard: string = "Dashboard";
export const PageLayout: string = "Page Layout";
export const ECommerce: string = "ECommerce";
export const FormLayout: string = "Form Layout";
export const Calendar: string = "Calender";
export const Users: string = "Users";

// Header
export const Notifications: string = "Notifications";
export const CheckAll: string = "Check all";
export const Bookmark: string = "Bookmarks";
export const AddNewBookmark: string = "Add New Bookmark";
export const Back: string = "Back";
export const OrderTotal: string = "Order Total";
export const GoToYourCart: string = "Go to your cart";
export const Checkout: string = "Checkout";
export const EN: string = "EN";
export const HelenWalter: string = "Helen Walter";
export const Admin: string = "Admin";
export const SearchBoho: string = "Search Boho ..";
export const SearchbarEmptyText = "Your search turned up 0 results. This most likely means the backend is down, yikes!";
export const SearchHere = "Search here...";
export const Quickoption: string = "Quick option";

// sidebar
export const Pinned: string = "Pinned";

//Footer
export const FooterLeft: string = "Copyright 2023 © Boho theme by pixelstrap ";
export const FooterRight: string = "Hand crafted & made with";

//Ui Kits- Typography
export const Headings: string = "Headings";
export const Code: string = "Code";
export const FontSize: string = "FontSize";
export const Heading: string = "Heading";
export const ColoredHeadings: string = "Colored Headings";
export const FontWeight: string = "Font Weight";
export const FontWeightTitle: string = "You can set bolder font weight Heading";
export const ListingTypography: string = "Listing Typography";
export const UnorderList: string = "Unorder list";
export const OrderLists: string = "Order list";
export const DisplayHeadings: string = "Display headings";
export const InlineTextElements: string = "Inline text elements";
export const Mark: string = "You can use the mark tag to";
export const Highlight: string = "highlight";
export const Del: string = "This line of text is meant to be treated as deleted text.";
export const Stext: string = "This line of text is meant to be treated as no longer accurate.";
export const InstText: string = "This line of text is meant to be treated as an addition to the document.";
export const Utext: string = "This line of text will render as underlined";
export const SmallText: string = "This line of text is meant to be treated as fine print.";
export const StrongText: string = "This line rendered as bold text.";
export const EmTeaxt: string = "This line rendered as italicized text.";
export const TextColor: string = "Text Color";
export const Blockquotes: string = "Blockquotes";

//Ui Kits- Avatars
export const Avatars: string = "Avatars";
export const Sizes: string = "Sizes";
export const StatusIndicator: string = "Status Indicator";
export const Shapes: string = "Shapes";
export const Ratio: string = "Ratio";
export const Grouping: string = "Grouping";

//Ui Kits- Tag And Pills
export const TagAndPills: string = "Tag & Pills";
export const BadgesContextualVariations: string = "Badges Contextual Variations";
export const PillsContextualVariations: string = "Pills Contextual Variations";
export const NumberOfBadge: string = "Number of Badge ";
export const Messages: string = "Messages";
export const NumberOfPillsTags: string = "Number of Pills Tags";
export const BadgeTagsWithIcons: string = "Badge Tags With Icons";
export const RoundedPillsWithIcons: string = "Rounded Pills With Icons";
export const BadgeHeadingsExample: string = "Badge Headings Example";
export const BadgesAsPartButtons: string = "Badges As Part Buttons";

////Ui Kits- Helper Classes
export const BordersAndDisplays: string = "Borders And Displays";
export const AdditiveBorder: string = "Additive Border ";
export const SubtractiveBorder: string = "Subtractive Border";
export const AdditiveRadiu: string = "Additive Radius";
export const StylerBorders: string = "Styles In Borders";
export const CustomBorderRadiusClass: string = "Custom Border-radius Class";
export const BorderColor: string = "Border Color";
export const BorderWidth: string = "Border-Width";
export const TextColors: string = "Text Colors";
export const BackgroundColors: string = "Background Colors";
export const DarkBackground: string = "Dark Background";
export const LightBackground: string = "Light Backgrounds";
export const ExtendedBackgroundColor: string = "Extended Background Colors";
export const ImagesSizes: string = "Images Sizes";
export const FontStyle: string = "Font-Style";
export const FontSizes: string = "Font Sizes";

//Ui Kits- Grid
export const GridOptions: string = "Grid Options";
export const GridBehavior: string = "Grid behavior";
export const HorizontalAllTimes: string = "Horizontal at all times";
export const CollapsedBreakpoints: string = "Collapsed to start, horizontal above breakpoints";
export const MaxContainerWidth: string = "Max container width";
export const ClassPrefix: string = "Class prefix";
export const GridForColumn: string = "Grid For Column";
export const VerticalAlignment: string = "Vertical Alignment";
export const Class: string = " Class";
export const ValueOfClass: string = "Value of the class";
export const VerticalAlignmentClass: string = ".align-items-*";
export const VerticalAlignmentValueClass: string = " start / center / end / baseline / stretch";
export const HorizontalAlignment: string = "Horizontal Alignment";
export const HorizontalAlignmentValueClass: string = "start / center / end / around / between";
export const HorizontalAlignmentClass: string = ".justify-content-*";
export const Nesting: string = "Nesting";
export const Order: string = "Order";
export const OrderClass: string = ".order-*";
export const OrderValueClass: string = " first / 2 / 3 / 4 / 5 / last";
export const Offset: string = "Offset";
export const OffsetClass: string = ".offset-*";
export const OffsetValueClass: string = " 1 / 2 / ... / 11 / 12";

//Ui Kits- Tabs
export const BootstrapTabs: string = "Bootstrap Tabs";
export const Tabs: string = "Tabs";
export const SimpleTab: string = "Simple tabs";
export const IconsWithTab: string = "Icons With Tabs";
export const VerticalTab: string = "Vertical Tabs";
export const PillsTab: string = "Pills tabs";
export const JustifyTab: string = "Justify Tabs";
export const MaterialStyleLeftTab: string = "Material Style Left Tabs";
export const DalbultCaslin: string = "Dalbult Caslin ";
export const MaterialStyleTab: string = "Material Style Tabs";
export const BorderTab: string = "Border Tabs ";
export const Home: string = "Home";
export const Profile: string = "Profile";
export const Contact: string = "Contact";
export const Components: string = "Components";
export const PageTab: string = "Page";
export const Settings: string = "Settings";
export const AboutUs: string = "About us";
export const ContactUs: string = "Contact us";
export const Blog: string = "Blog";
export const Inbox: string = "Inbox";
export const UxDesigner: string = "UX designer";
export const IOTDeveloper: string = "IOT developer";
export const BohoProfilesForNewEmployees: string = "Boho Profiles For New Employees:";
export const User: string = "User";
export const Description: string = "Description";
export const Review: string = "Review";

//Ui Kits- Dropdown
export const DropdownTitle: string = "Dropdown";
export const Dropdown: string = "Dropdown";
export const BasicDropdowns: string = "Basic Dropdown";
export const Primary: string = "Primary";
export const RoundedDropdowns: string = "Rounded Dropdown";
export const SplitDropdowns: string = "Split Dropdown";
export const Widgets: string = "Widgets";
export const Party: string = "Party";
export const Inputs: string = "Inputs";
export const HeadingDropdowns: string = "Heading Dropdown";
export const WithInputTypes: string = "With Input Type";
export const DarkDropdowns: string = "Dark Dropdown";
export const DarkNight: string = "Dark Night";
export const UniqueDropdow: string = "Unique Dropdow";
export const DropdownForms: string = "Dropdown form";
export const Text: string = "Text";
export const JustifyContent: string = "Justify Contents";
export const TextLeft: string = "Text-left";
export const Alignment: string = "Alignments";
export const WarningTop: string = "Warning top";
export const HelperCards: string = "Helper Card";
export const LearnMore: string = "Learn More!";
export const WarningCards: string = "Warning Card";
export const Warning: string = "Warning!";
export const AlertCards: string = "Alert Card";
export const Danger: string = "Danger";
export const DividerDropdowns: string = "Divider Dropdown";
export const Wishlist: string = "Wishlist";
export const DropdownSizings: string = "Dropdown Sizing";
export const LargeButton: string = "Large button";
export const SignIn: string = "Sign in";

//Accordion
export const Accordions: string = "Accordion";
export const SimpleAccordions: string = "Simple Accordion";
export const SimpleAccordion2: string = "<p> <strong> Search engine optimization: </strong> Search engine optimization (SEO) is a method for improving the chances for a website to be found by search engines. Web design codes information in a way that search engines can read it. It can boost business because the site shows up on the top search result pages, helping people to find it. <br /> <br /> <strong> Mobile responsiveness:</strong> Mobile responsiveness is the feature of a website that allows it to display on a mobile device and adapt its layout and proportions to be legible. Web design ensures sites are easy to view and navigate from mobile devices. When a website is well-designed and mobile-responsive, customers can reach the business with ease. <br /> <br /> <strong> Improved sales:</strong>Increasing the number of items sold or acquiring more active customers are objectives of a compelling website. As web design reaches targeted customers and search engines, it helps the business make conversions on their site and improve its sales. </p>";
export const SimpleAccordion3: string = "<p> The web design process allows designers to adjust to any preferences and provide effective solutions. There are many standard components of every web design, including: <br /> --> Layout <br /> --> Images <br /> --> Visual hierarchy <br /> --> Color scheme <br /> --> Typography <br /> --> Navigation <br /> --> Readability <br /> --> Content </p>";
export const FlushAccordions: string = "Flush Accordion";
export const WhatDoWebDesignersDo: string = "What do web designers do ?";
export const FlusAccordion2: string = "<p>First and foremost, Bootstrap is easy to learn. Due to its popularity, plenty of tutorials and online forums are available to help you get started.<br>One of the reasons why Bootstrap is so popular among web developers and web designers is that it has a simple file structure. Its files are compiled for easy access, and it only requires basic knowledge of HTML, CSS, and JS to modify them.<br>You can also use themes for popular content management systems as learning tools. For example, most WordPress themes were developed using Bootstrap, which any beginner web developer can access. <br>To increase the site's page load time, Bootstrap minifies the CSS and JavaScript files. Additionally, Bootstrap maintains consistency across the syntax between websites and developers, which is ideal for team-based projects.</p>";
export const FlusAccordion3: string = "<p>Bootstrap handles the image display and responsiveness with its predefined HTML and CSS rules.<br>Adding the .img-responsive class will automatically resize images based on the users' screen size. This will benefit your website’s performance, as reducing image sizes is part of the site optimization process.<br>Bootstrap also provides additional classes like .img-circle and .img-rounded, which help to modify the images' shape.</p>";
export const MultipleCollapseAccordions: string = "Multiple Collapse Accordion";
export const ToggleFirstElement: string = "Toggle first element";
export const ToggleSecondElement: string = "Toggle second element";
export const ToggleBothElement: string = "Toggle second element";
export const WithIconsAccordions: string = "With Icons Accordion";
export const IconAccordion2: string = "<p>You get the same features in Chat and Chat in Gmail, but the integrated Gmail experience provides a central location to communicate with friends, family, or coworkers between emails.<br><strong> Chat:</strong> Use when you prefer a dedicated chat experience and don't mind switching between different apps.</p>";
export const IconAccordion3: string = "<p>1) Decide on the indentation and keep it that way.<br>2) Make comments.<br>3) Consistent name scheme.<br>4) Don't repeat code.<br>5) Avoid writing long code lines.<br>6) Break down a big task into smaller chunks.<br>7) Organize your program into smaller files.<br>8) Write clever code that is also readable.</p>";
export const OutlineAccordions: string = "Outline Accordion ";
export const HorizontalAccordions: string = "Horizontal Accordion";
export const ToggleWidthCollapse: string = "Toggle width collapse";
export const CollapseAccordions: string = "Collapse Accordion";
export const LinkwithHref: string = "Link with href";
export const ButtonWithDataBsTarget: string = "Button with data-bs-target";

// Alert
export const Alert: string = "Alert";
export const LinkColorDarkTheme: string = "Link Color In Dark Theme";
export const LinkColorLightTheme: string = "Link Color In Light Theme";
export const OutlineDarkLightAlerts: string = "Outline Dark And Light Alerts";
export const AlertsWithIconsTextActions: string = "Alerts With Icons and Text Actions";
export const DismissingDarkAlert: string = "Dismissing Dark Alerts";
export const DismissingLightAlert: string = "Dismissing Light Alerts";
export const LiveAlerts: string = "Live Alert";
export const ShowLiveAlert: string = "Show live alert";
export const LeftBorderAlerts: string = "Left Border Alert";
export const AdditionalContents: string = "Additional content";
export const PleaseCheckYourNotifications: string = "Please! Check your notifications";

//Ui Kits- Popover
export const Popover: string = "Popover";
export const HurryUps: string = "Hurry Up!";
export const BasicPopovers: string = "Basic Popover";
export const PopoverOnTop: string = " Popover on top";
export const PopoverOffsets: string = "Popover Offset ";
export const PopoverDirections: string = "Popover Direction";
export const PopoverOffset50: string = "Popover offset 50";

//Ui Kits- Tooltip
export const Tooltip: string = "Tooltip";
export const BasicTooltips: string = "Basic Tooltip";
export const Button: string = "button";
export const MagicPleaseHoverMe: string = "It's magic please hover me...";
export const InlineTooltipContent: string = "Inline Tooltip Content";
export const ColoredTooltips: string = "Colored Tooltip ";
export const DirectionsdTooltip: string = "Tooltip  Directions";
export const TooltipOnTop: string = "Tooltip on tops";
export const HTMLElementsWithHoverEffect: string = "HTML Elements With Hover Effect";
export const NotificationsReceived: string = "Notifications Received";
export const FilledTooltips: string = "Filled Tooltip";
export const TooltipInfo: string = "Tooltip Info";
export const ThankYouBold: string = "<b>Thank</b> <em>you</em>";
export const ThankYouItalic: string = "<i>Thank </i> <u>you</u>";

//Ui Kits- Progress
export const Progress: string = "Progress";
export const BasicProgressBars: string = "Basic Progress Bars";
export const ProgressBarsStriped: string = "Progress Bars Striped";
export const ProgressBarsAnimated: string = "Progress Bars animated";
export const MultipleBars: string = "Multiple bars";
export const ProgressWithNumberSteps: string = "Progress With Number Steps";
export const CustomProgressBars: string = "Custom Progress Bars";
export const SmallProgressBars: string = "Small Progress Bars";
export const LargeProgressBars: string = "Large Progress Bars";
export const GettingStarted: string = "0% Getting Started ";
export const CustomHeightProgressBars: string = "Custom Height Progress Bars";

//Ui Kits- Modal
export const Modal: string = "Modal";
export const BasicModal: string = "Basic Modal";
export const Simple: string = "Simple";
export const ScrollingContent: string = "Scrolling content";
export const UXDesigners: string = "UX Designer ";
export const WebDesigns: string = "Web Design ";
export const WebDesigner: string = "Web Designer ";
export const TooltipsAndPopovers: string = "Tooltips and popovers";
export const PopoverModal: string = "Popover in a modal";
export const TooltipsModal: string = "Tooltips in a modal";
export const OpenModalForBoho: string = "Open modal for Boho";
export const SizesModal: string = "Sizes Modal";
export const FullScreenModals: string = "Full Screen Modal";
export const ExtraLargeModals: string = "Extra large Modal";
export const LargeModals: string = "Large Modal";
export const SmallModals: string = "Small Modal";
export const FullScreenModal: string = "Fullscreen Modal";
export const FullScreenBelowSM: string = "Full Screen Below sm";
export const FullScreenBelowMD: string = "Full Screen Below md";
export const FullScreenBelowLG: string = "Full Screen Below lg";
export const FullScreenBelowXL: string = "Full Screen Below xl";
export const FullScreenBelowXXL: string = "Full Screen Below xxl";
export const CenteredModals: string = "Centered Modal ";
export const VerticallyCentered: string = "Vertically centered";
export const ToggleBetweenModal: string = "Toggle Between Modals ";
export const OpenFirstModal: string = "Open first Modal ";
export const StaticBackdropModals: string = "Static Backdrop Modal";
export const BohoCustomModal: string = "Boho Custom Modals ";
export const YourBalance: string = "Your Balance ";
export const BalanceAmount: string = "$768,987.90";
export const BrooklynSimmons: string = "Brooklyn Simmons";
export const ProfileUserName: string = "@brookly.simmons";
export const PostCount: string = "1,908";
export const Posts: string = "Posts";
export const Cancel: string = "Cancel";
export const Close: string = "Close";
export const SaveChanges: string = "Save changes";
export const ClickOut: string = "Click Out";
export const BohoSignUp: string = "Boho SIGN-UP";
export const BohoLogin: string = "Boho Login";
export const StaticBackdropModalBtn: string = "Static backdrop modal";
export const SomethingWentWrong: string = "Ohh! Something went wrong!";
export const AlreadyLeaving: string = "Already leaving??";
export const YesLogOut: string = "Yes, Log out";
export const ParentToggleTitle: string = "Remove your complete account from your phone or tablet to sign out of the Gmail app.";
export const ConnectNewAccount: string = "Connect new account";
export const AlertMessage: string = "Attackers on malicious activity may trick you into doing something dangrous like installing software or revealing your personal informations.";

//Icons - Flag Icons
export const FlagIcon: string = "Flag Icons";

//Icons- Font Awesome Icon
export const FontAwesomeIcons: string = "Font Awesome Icon";
export const Currency: string = "Currency";
export const WebApp: string = "Web App";
export const Spinner: string = "Spinner";
export const FormControl: string = "Form Control";
export const TextEditor: string = "Text Editor";
export const Directional: string = "Directional";
export const VideoPlayer: string = "Video Player";
export const BrandPlayer: string = "Brand Player";
export const Medical: string = "Medical";

//Ico Icons
export const IcoIcon: string = "ICO Icon";
export const Abstract: string = "Abstract";
export const Sport: string = "Sport";
export const Social: string = "Social";
export const Weather: string = "Weather";
export const WebApplication: string = "Web Application";
export const Travel: string = "Travel";
export const Transport: string = "Transport";
export const Multimedia: string = "Multi media";
export const MobileUI: string = "Mobile UI";
export const Mathematical: string = "Mathematical";
export const Animal: string = "Animal";
export const Brand: string = "Brand";
export const Construction: string = "Construction";
export const Device: string = "Device";
export const Education: string = "Education";
export const FileType: string = "File Type";
export const Food: string = "Food";
export const Law: string = "Law";
export const Business: string = "Business";
export const Emoticon: string = "Emoticon";
export const KidsToys: string = "Kids & Toys";
export const Payment: string = "Payment";
export const Person: string = "Person";

//Themify Icon
export const ThemifyIcon: string = "Themify Icon";
export const ArrowsDirection: string = "Arrows & Direction ";
export const Control: string = "Control";

//Feather Icons
export const FeatherIcons: string = "Feather Icons";

//whether icons
export const WhetherIcon = "Whether Icon";
export const whetherIconsWithAnimations = "Whether Icons With Animations";
export const CopyText = "Copy text";
export const Markup = "Markup";

//Ui Kits - Lists
export const Lists: string = "Lists";
export const DefaultList: string = "Default Lists ";
export const ActiveList: string = "Active Lists ";
export const FlushList: string = "Flush Lists";
export const ContextualClasse: string = "Contextual classes";
export const HorizontalList: string = "Horizontal Lists";
export const CustomContentList: string = "Custom Content Lists";
export const MollyBoake: string = "Molly Boake";
export const ListsWithCheckboxs: string = "Lists With Checkbox";
export const ListsWithRadio: string = "Lists With Radios";
export const ListsWithNumber: string = "Lists With Numbers";
export const JavaScriptBehaviors: string = "JavaScript Behavior";
export const NumberedBadgeList: string = "Numbered & Badge Lists";
export const DisabledList: string = "Disabled Lists ";
export const ScrollableList: string = "Scrollable Lists ";

// Buttons - default style
export const DefaultStyle: string = "Default Style";
export const DefaultButton: string = "Default buttons";
export const SmallButton: string = "Small buttons";
export const ExtraSmallButton: string = "Extra Small buttons";
export const ActiveButton: string = "Active Buttons";
export const DisabledButton: string = "Disabled buttons";
export const CustomStateButton: string = "Custom state buttons";
export const OutlineButton: string = "outline buttons";
export const BoldBorderOutlineButton: string = "bold Border outline buttons";
export const OutlineLargeButton: string = "outline Large buttons";
export const OutlineSmallButton: string = "outline small buttons";
export const OutlineExtraSmallButton: string = "Outline extra small buttons";
export const DisabledOutlineButton: string = "Disabled outline buttons";
export const GradienButton: string = "Gradien buttons";
export const PrimaryButton: string = "Primary Button";
export const Active: string = "Active";
export const Disabled: string = "Disabled";
export const Link: string = "Link";
export const Input: string = "Input";
export const Submit: string = "Submit";

//Buttons- Flat style
export const FlatButton: string = "Flat Buttons";

//Buttons- Edge style
export const EdgeButton: string = "Edge Buttons";

//Buttons- Raised style
export const RaisedButton: string = "Raised Buttons";

//Bonus Ui - Scrollable
export const Scrollable: string = "Scrollable";
export const CustomScrollbars: string = "Custom Scrollbar";
export const SmallSizeScrollbars: string = "Small Size Scrollbar";
export const SolutionBusinessTransformation: string = "Solution for Business Transformation";
export const BadgesScrollbars: string = "Badges Scrollbar";
export const ProfileScrollables: string = "Profile Scrollable";
export const ScrollableContents: string = "Scrollable Content";
export const HorizontalScrollbars: string = "Horizontal Scrollbar ";
export const BothSideVisibleScrollbars: string = "Both Side Visible Scrollbar";

//Buttons - Groups
export const ButtonGroup: string = "Button Group";
export const BasiButtonGroups: string = "Basic button group";
export const Left: string = "Left";
export const Middle: string = "Middle";
export const Right: string = "Right";
export const EdgesButtonGroups: string = "Edges button group";
export const LargeEdgesButtonGroups: string = "Large Edges Button group";
export const FlatButtonGroups: string = "Flat button group";
export const LargeButtonGroups: string = "Large Button group";
export const OutlineCustomeButtonGroups: string = "Outline Custom button group";
export const OutlineButtonGroups: string = "Outline button group";
export const OutlineEdgeButton: string = "Outline Edges button";
export const OutlineFlatButtons: string = "Outline flat button";
export const RadioButtonGroups: string = "Radio button groupn";
export const CheckBoxButtonGroups: string = "Radio button groupn";
export const OptionOne: string = "Option 1";
export const OptionTwo: string = "Option 2";
export const NestingButton: string = "Nesting";
export const DropdownLink: string = "Dropdown link";
export const VerticalGroupButton: string = "Vertical";

//Bonus Ui - Tree View
export const TreeView: string = "Tree View";
export const BasicTree: string = "Basic View";
export const DisabledTrees: string = "Disabled Tree";

//Bonus Ui - Toasts
export const Toasts: string = "Toasts";
export const LiveToasts: string = "Live Toast";
export const TopRightToasts: string = "Top-right toast";
export const BottomRightToasts: string = "Bottom-right toast";
export const TopLeftToasts: string = "Top-left toast";
export const BottomLeftToasts: string = "Bottom-left toast";
export const YourAccountWillBePermanentlyDeleted: string = "Your account will be permanently deleted?";
export const ImNotSure: string = "I'm not sure";
export const RemoveMyAccount: string = "Remove My Account";
export const ColorsScheme: string = "Colors Schemes";
export const StackingToast: string = "Stacking Toasts";
export const TranslucentToast: string = "Translucent Toasts";
export const DefaultToasts: string = "Default Toast";
export const UniqueToasts: string = "Unique Toast";
export const DoYouIntendToContinue: string = "Do you intend to continue?";
export const ToastPlacements: string = "Toast Placement";

//Bonus Ui - Toasts
export const BarRating: string = "Rating Bar";
export const RatingBars: string = "1 to 10 Rating Bar";

//Bonus Ui - Rating
export const StarRatingBar: string = "Star Rating Bar";
export const ReversedRatingBar: string = "Reversed Rating Bar";
export const RatingWithTooltip: string = "Rating With Tooltip";
export const FontawesomeThumbsUpDownRating: string = "Fontawesome Thumbs Up/Down rating";
export const CurrentRatingBar: string = "Current Rating Bar";

//Bonus Ui - Dropzone
export const Dropzone: string = "Dropzone";
export const DefaultFileUploads: string = "Default File Upload";
export const PreviewImage: string = "Image Preview ";
export const SingleFileUploads: string = "Single File Upload";
export const MultiFileUploads: string = "Multi File Upload";
export const DropFilesHereOrClickToUpload: string = "Drop files here or click to upload.";

//Bonus Ui - Tour
export const Tour: string = "Tour";
export const WilliamJennings: string = "William C. Jennings";
export const WebDesignerTour: string = " Web Designer";
export const FollowerTour: string = "Follower";
export const FollowingrTour: string = "Following";
export const WonderfullTour: string = "Wonderful piece that successfully conveys the magnificence of the mountains and the natural world.";
export const ReadMoreTour: string = "ReadMore";
export const PainterTourTitle: string = "English Romantic painter, printer, and watercolourist ";

//Learnings - Learning List
export const LearningList: string = "Learning List";
export const LearningCardsDetails = "Java is an object-oriented programming language. Sun Microsystems first released Java in the year 1995. It is popularly used for developing Java applications in data centers, laptops, cell phones, game consoles, and scientific supercomputers. There are multiple websites and applications which will not work if Java is not installed.";
export const BlogByLearning = "by:";
export const HitsLearning = "Hits";
export const LearningFilter = "Learning filter";
export const FindCourseLearning = "Find Course";
export const FilterLearning = "Filter";
export const SearchLearningPlaceholder = "Search..";
export const CategoriesLearning = "Categories";
export const CategoriesTitleLearning = "Categories";
export const DurationLearning = "Duration";
export const PriceLearning = "Price";
export const StatusLearning = "Status";
export const RegistrationLearning = "Registration";
export const DevelopmentTitle = "Development";
export const DesignLearnig = "Design";
export const UpcomingCoursesHeading = "Upcoming Courses";
export const CourseBy = "Course By";

//Learnings - Detailed Course
export const DetailedCourse = "Detailed Course";
export const CommentsLearning: string = "Comments";
export const DateLearning: string = "25 July 2023";
export const DetailedCourseHeading = `Knowledge can be defined as awareness of facts or as practical skills. there is wide agreement among philosophers that it is a form of true belief.`;
export const DetailedCourseParagraph1 = `Knowledge can be defined as awareness of facts or as practical skills, and may also refer to familiarity with objects or situations. Knowledge of facts, also called propositional knowledge, is often defined as true belief that is distinct from opinion or guesswork by virtue of justification. While there is wide agreement among philosophers that it is a form of true belief, many controversies in philosophy focus on justification: whether it is needed at all, how to understand it, and whether something else besides it is needed.`;
export const DetailedCourseParagraph2 = `Knowledge can be produced in many different ways. The most important source is perception, which refers to the usage of the five senses. Many theorists also include introspection as a source of knowledge, not of external physical objects, but of one's own mental states. Other sources often discussed include memory, rational intuition, inference, and testimony. According to foundationalism, some of these sources are basic in the sense that they can justify beliefs without depending on other mental states. This claim is rejected by coherentists.`;
export const CommentTitleLearning: string = "Comments";
export const LearningCommentOne: string = "The best thing is location and drive through the forest. The resort is 35km from Ramnagar. The gardens are well kept and maintained. Its a good place for relaxation away from the city noise. The staff is very friendly and overall we had a really good & fun time, thanks to staff member - Bhairav, Rajat, Gunanand, Lokesh & everyone else. And also we went for an adventurous night safari and saw barking deers, tuskar elephant.";
export const LearningCommentTwo: string = "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.";

//Bootstrap Table - Basic Table
export const BootstrapBasicTable: string = "Bootstrap Basic Tables";
export const BasicTableWithBorderBottomColor: string = "Basic Table With Border Bottom Color";
export const InverseTables: string = "Inverse Table";
export const HoverableRowsWithHorizontalBorders: string = "Hoverable Rows With Horizontal Border";
export const InverseTablWithPrimaryBackgrounds: string = "Inverse Table with Primary background";
export const CaptionTableTitle: string = "Caption";
export const UserList: string = "List of users";
export const TableHeadOption: string = "Table head options";
export const StripedRowWithInverseTables: string = "Striped Row with Inverse Table";
export const BreckpointSpecifics: string = "Breckpoint Specific";
export const ResponsiveLightBackgroundTitle: string = "Responsive Tables With Light Background";
export const SizingTable: string = "Sizing Tables";
export const CustomColorHoverStrippedTitle: string = "Custom Table Color With Hover And Stripped";
export const DashedBorderTitle: string = "Dashed Border";

//Bootstrap Table - Table Components
export const TableComponent: string = "Table Components";
export const UIComponentsTitle = "UI Components";
export const DefaultButtonsTitle = "Default Buttons";
export const AlertTitle = "Alerts";
export const ProgressbarTitle = "Progressbar";
export const CheckboxTitle = "Checkbox";
export const RadioButtonsTitle = "Radio Buttons";
export const SelectTable = "Select";
export const InputsTable = "Input";
export const BadgesTable = "Badges";
export const TooltipTriggersTitle = "Tooltip Triggers";
export const SwitchTable = "SWITCH";

//Data Tables - Basic Data Tables
export const BasicDataTables: string = "Basic DataTables";
export const ZeroConfiguration = "Zero Configuration";
export const SearchTableButton = "Search";
export const StateSavingTitle = "State saving";
export const StateSavingSpan1 = `DataTables has the option of being able to save the state of a table (its paging position, ordering state etc) so that is can be restored when the user reloads a page, or comes back to the page after visiting a sub-page. This state saving ability is enabled by the <code class="option" title="DataTables initialisation option">stateSave</code> option.`;
export const StateSavingSpan2 = `The built in state saving method uses the HTML5 <code>localStorage</code> and <code>sessionStorage</code> APIs for efficient storage of the data. Please note that this means that the built in state saving option <strong>will not work with IE6/7</strong> as these browsers do not support these APIs. Alternative options of using cookies or saving the state on the server through Ajax can be used through the <code class="option" title="DataTables initialisation option">stateSaveCallback</code> and <a href="//datatables.net/reference/option/stateLoadCallback"><code class="option" title="DataTables initialisation option">stateLoadCallback</code></a> options.`;
export const StateSavingSpan3 = `The duration for which the saved state is valid and can be used to restore the table state can be set using the <code class="option" title="DataTables initialisation option">stateDuration</code> initialisation parameter (2 hours by default). This parameter also controls if <code>localStorage</code> (0 or greater) or <code>sessionStorage</code> (-1) is used to store the data..`;
export const StateSavingSpan4 = `The example below simply shows state saving enabled in DataTables with the <code class="option" title="DataTables initialisation option">stateSave</code> option.`;
export const ScrollVerticalDynamicHeightTitle = "Scroll - vertical, dynamic height";

export const ScrollVaertical1 = `This example shows a vertically scrolling DataTable that makes use of the CSS3 vh unit in order to dynamically resize the viewport based on the browser window height. The vh unit is effectively a percentage of the browser window height. So the 50vh used in this example is 50% of the window height. The viewport size will update dynamically as the window is resized.`;
export const ScrollVaertical2 = `A relatively modern browser is required for vh units to operate correctly. IE9+ supports the vh unit and all other evergreen browsers.`;
export const ZeroConfiguration1 = `DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.`;
export const ZeroConfiguration2 = `earching, ordering and paging goodness will be immediately added to the table, as shown in this example.`;

//Data Tables - Advance Init
export const AdvanceInitTitle = `Advance Init`;
export const StockResult = `Stock Result`;
export const StockResultSpan1 = `Data within DataTables can be easily rendered to add graphics or colour to your tables, as demonstrated in the example on this page. These examples make use of columns.render and drawCallback to customise the cells in three ways:`;
export const StockResultSpan2 = `1. the colour of the cell is determine by the relative price of the stock.`;
export const StockResultSpan3 = `2. a 'sparkline' class is added to the numeric array in the 'last' column.`;
export const RowCreateCallBackSpan = "Row Create Callback";
export const RowCreateCallSpan1 = "For each row that is generated for display, the createdRow function is called once and once only. It is passed the create row node which can then be modified.";
export const RowCreateCallSpan2 = "the 'salary' column Primary and bold by adding a CSS class to the container cell if the salary is greater than $150,000.";
export const RowCreateCallSpan3 = "the 'salary' column danger and bold by adding a CSS class to the container cell if the salary is less than $40,000.";
export const APIDataTables = "API DataTables";
export const AddRowsTitle = "Add rows";
export const AddNewRowButoon = "Add new row";
export const ChildrenRowsTitle = "Child rows (show extra / detailed information)";
export const ApiFullName = "Full Name: ";
export const ExtraInfo = "Extra info ";
export const ApiExtensionNumber = "Extension number: ";
export const ApiExtraInfo = "'And any further details here (images etc)...'";
export const RowsSelectionAndDeletions = "Row Selection And Deletion (Single Row)";
export const RowSelectionAndDeletionHeaderSpan = `It can be useful to provide the user with the option to select rows in a DataTable. This can be done by using a click event to add / remove a class on the table rows. The
<code className="api" title="DataTables API method">
rows().data()
</code>
method can then be used to get the data for the selected rows. In this case it is simply counting the number of selected rows, but much more complex interactions can easily be developed.`;
export const DeleteSelectDataButton = "Delete Row";
export const CustomFilteringSearch = "Custom filtering - range search";
export const MinimumAge = "Minimum age: ";
export const MaximumAge = "Maximum age:	";
export const DATASourceDataTables = "DATA Source DataTables";
export const HtmlTableTittle = "HTML (DOM) sourced data";
export const AjaxSourcedDataHeading = "Ajax sourced data";
export const JavascriptSourcedDataHeading = "Javascript sourced data";
export const JavascriptSourcedSpan1 = `At times you will wish to be able to create a table from dynamic information passed directly to DataTables, rather than having it read from the document. 
This is achieved using the <code class="option" title="DataTables initialisation option">data</code>                                   option in the initialisation object, passing in an array of data to be used (like all other DataTables handled data, this can be arrays or objects using the<code class="option" title="DataTables initialisation option">columns.data</code> option).`;
export const JavascriptSourcedSpan2 = `A <code class="tag" title="HTML tag">table</code> must be available on the page for DataTables to use. This examples shows an empty <code class="tag" title="HTML tag">table</code> element being initialising as a DataTable with a set of data from a Javascript array. The columns in the table are dynamically created
based on the <code class="option" title="DataTables initialisation option">columns.title</code>                                   configuration option.`;
export const ServerSideProcessingHeading = "Server-side processing";
export const ServerSideProcessingSpan1 = `here are many ways to get your data into DataTables, and if you are working with seriously large databases, you might want to consider using the server-side options that DataTables provides. With server-side processing enabled, all paging, searching, ordering actions that DataTables performs are handed off to a server where an SQL engine (or similar) can perform these actions on the large data set (after all, that's what the database engine is designed for!). As such, each draw of the table will result in a new Ajax request being made to get the required data.`;
export const ServerSideProcessingSpan2 = `Server-side processing is enabled by setting the <code class="option" title="DataTables initialisation option">serverSide:option</code> option to <code>true</code> and providing an Ajax data source through the <code class="option" title="DataTables initialisation option">ajax:option</code> option.`;

//Validation Forms - Tooltip validation
export const ValidationForms: string = "Validation Forms";
export const FormValidationTooltip: string = "Tooltip form validation";
export const FirstName: string = "First name";
export const LastName: string = "Last name";
export const Username: string = "Username";
export const LooksGood: string = "Looks good!";
export const UsernameFeedback: string = "Please choose a unique and valid username.";
export const City: string = "City";
export const Zip: string = "Zip";
export const State: string = "State";
export const StateChoose: string = "Choose...";
export const CityFeedback: string = "Please provide a valid city.";
export const StateFeedback: string = "Please select a valid state.";
export const ZipFeedback: string = "Please provide a valid zip.";
export const SubmitButton: string = "Submit form";
export const MarkFirstNamePlaceholder: string = "Mark";
export const ottolastNamePlaceholder: string = "Otto";
export const OttolastNamePlaceholder: string = "Otto";

//Validation Forms - Browser defaults
export const BrowserDefault: string = "Browser defaults";
export const FirstNamePlaceholder: string = "First name";
export const EmailAddress: string = "Email address";
export const EmailPlaceholder: string = "pesamof475@saeoil.com";
export const PasswordBrowserDefault: string = "Password";
export const ChooseFile: string = "Choose file";
export const SelectYourPaymentMethod: string = "Select your payment method";
export const Visa: string = "Visa";
export const MasterCard: string = "MasterCard";
export const Paypal: string = "Paypal";
export const PayMethodTitle: string = "Select your payment method";
export const AgreeToThePolicies: string = "I agree to the policies";
export const SureInformation: string = "Are you sure above information are true";

//Validation Forms - Validation form
export const ValidationsForms: string = "Validation form";
export const FirstNameError: string = "Please enter your valid firstname";
export const FirstNameFeedback: string = "Please enter your valid";
export const Passwordvalidation: string = "Password";
export const PasswordFeedback: string = "Please enter your valid password";
export const StateInvalidFeedback: string = "Please select a valid state.";
export const CityInvalidFeedback: string = "Please provide a valid city..";
export const ZipInvalidFeedback: string = "Please provide a valid zip.";
export const VISA: string = "VISA";
export const SelectThemeTitle: string = "Select Your Favorite Pixelstrap theme";
export const ThemeError: string = "Invalid select feedback";
export const ChooseFiles: string = "Choose File";
export const InvalidFormFileSelected: string = "Invalid form file selected";
export const TextAreaPlaceHolder: string = "Enter your comment";
export const TextAreaError: string = "Please enter a message in the textarea.";
export const TermsError: string = "You must agree before submitting.";
export const AgreeCondition: string = "Agree to terms and conditions";
export const AgreeSubmitting: string = "You must agree before submitting.";

//Base Input
export const BaseInputs: string = "Base inputs";
export const FormBasic: string = "Basic form";
export const EmailLabel: string = "Email";
export const EmailPlaceHolder: string = "Enter Your Email";
export const PasswordLabel: string = "Password";
export const PasswordPlaceholder: string = "Enter Your Password";
export const CheckMeOut: string = "Check me out";
export const SignInButton: string = "Sign in";
export const FormFloating: string = "Floating form";
export const EmailFloatingPlaceholder: string = "name@example.com";
export const PasswordFloatingPlaceholder: string = "Password";
export const FloatingPasswordPlaceholder: string = "Password";
export const SelectSizings: string = "Select sizing";
export const WhatsYourHobbies: string = "What's Your Hobbies";
export const FormControlSizings: string = "Form control sizing";
export const FormControlSizingsPlaceholder: string = ".form-control-sm";
export const FileInputs: string = "File input";
export const FlatInputStyles: string = "Flat input style";
export const SmallFileInputExample: string = "Small file input example";
export const LargeFileInputExample: string = "Large file input example";
export const SelectYourFavoriteRomanNumber: string = "Select your favorite roman number";
export const SelectYourMultiplePaintings: string = "Select your multiple paintings";
export const PleaseDoComments: string = "Please do comments";
export const BasicHtmlInputControls: string = "Basic HTML input control";
export const BasicPlaceholder: string = "Placeholder";
export const BasicPlaceholderPlace: string = "Type your title in Placeholder";
export const BasicPassword: string = "Password";
export const PasswordInputPlaceholder: string = "Password input";
export const BasicNumber: string = "Number";
export const NumberPlaceholder: string = "Number";
export const BasicTelephone: string = "Telephone";
export const BasicTelephonePlacholder: string = "91-(999)-999-999";
export const URLs: string = "URL";
export const URLsValue: string = "https://getbootstrap.com";
export const BasicDateAndTime: string = "Date and time";
export const FullDateAndTime: string = "2018-01-19T18:45:00";
export const BasicDate: string = "Date";
export const FullDate: string = "2018-01-01";
export const BasicMonth: string = "Month";
export const FullMonth: string = "2018-01";
export const BasicWeek: string = "Week";
export const FullWeek: string = "BasicWeek";
export const BasicDatalistExample: string = "Datalist example";
export const ListPlaceholder: string = "Look up your nation...";
export const BasicTime: string = "Time";
export const BasicColorPicker: string = "Color picker";
export const BasicMaximumLength: string = "Maximum Length";
export const MaximumLengthPlacholder: string = "Content must be in 6 characters";
export const BasicStaticText: string = "Static Text";
export const StaticTextData: string = "Hello !... This is my magical text";
export const BasicSubmitButton: string = "Submit";
export const BasicCancleButton: string = "Cancle";
export const BasicFloatingInputControls: string = "Basic floating input control";
export const FloatingValidInput: string = "Valid input ";
export const InputWithValue: string = "Input with value";
export const InvaliInput: string = "Invalid input";
export const FloatingComments: string = "Comments";
export const FloatingEmail: string = "Email";
export const FloatingPassword: string = "Password";
export const FloatingComment: string = "Comments";
export const FloatingCommentPlaceholder: string = "Leave a comment here";
export const FloatingCommentLabel: string = "Comments";
export const InputWithValuePlaceholder: string = "name@example.com";
export const InvalidInputPlaceholder: string = "name@example.com";
export const LayOutPlaceholder: string = "name@example.com";
export const LayOutDefaultvalue: string = "mdo@example.com";
export const CommentsPlaceholder: string = "Comments";
export const InputWithValuePlaceholderValue: string = "test@example.com";
export const InvalidInputPlaceholderValue: string = "test@example.com";
export const FloatingEmailLabel: string = "Email address";
export const FloatingOpenLabel: string = "Open this select menu";
export const FloatOpenFloatingLabel: string = "Works with selects";
export const FloatingInputGroup: string = "Input group";
export const FloatingInputGroupLabel: string = "Username";
export const FloatingInputGroupFeed: string = "Please choose a username.";
export const FloatingLayout: string = "Layout";
export const FloatingCancleButton: string = "Cancle";
export const FloatingSubmittButton: string = "Submit";
export const EdgesInputStyles: string = "Edges input style";
export const EdgeEmailAddress: string = "Email address";
export const EdgeEmailAddressPlaceholder: string = "name@example.com";
export const EdgePassword: string = "Password";
export const EdgePasswordPlaceholder: string = "Password";
export const SelectYourFavoritePixelstrapTheme: string = "Select your favorite pixelstrap theme";
export const DefaultFileInputExamples: string = "Default file input example";
export const EdgeDefaultInput: string = "Default Input";
export const EdgeDefaultInputPlaceholder: string = "Default Input";
export const EdgeMale: string = "Male";
export const EdgeFemale: string = "Female";
export const EdgeComments: string = "Comments";
export const EdgeSubmit: string = "Submit";
export const EdgeCancel: string = "Cancel";
export const RaiseInputStyles: string = "Raise input style";
export const RaisedEmailAddress: string = "Email address";
export const RaisedEmailAddressPlaceholder: string = "name@example.com";
export const RaisedPassword: string = "Password";
export const RaisedPasswordPlaceholder: string = "Password";
export const RaisedSubmit: string = "Submit";
export const RaisedCancel: string = "Cancel";
export const RaisedSelectYourFavoritePixelstrapTheme: string = "Select your favorite pixelstrap theme";
export const SelectTheColorYouLikeBelow: string = "Select the color you like below";
export const RaisedComments: string = "Comments";

//Checkbox & Radio
export const CheckboxAndRadio: string = "Checkbox & Radio";
export const DefaultCheckboxs: string = "Default checkbox";
export const DefaultCheck: string = "Default Checks";
export const Defaultcheckboxes: string = "Default checkbox";
export const CheckedCheckbox: string = "Checked checkbox";
export const DisabledChecks: string = "Disabled Checks";
export const Indeterminate: string = "Indeterminate";
export const IndeterminateCheckbox: string = "Indeterminate checkbox";
export const CustomCheckboxs: string = "Custom checkbox";
export const BorderedCheckbox: string = "Bordered Checkbox ";
export const PrimaryCheckboxPrimary: string = "Primary - checkbox-primary";
export const IconCheckbox: string = "Icon Checkbox ";
export const FilledCheckbox: string = "Filled Checkbox";
export const WarningCheckboxSolidWarning: string = "Warning - checkbox-solid-warning ";
export const DefaultRadios: string = "Default radio";
export const CustomRadio: string = "Custom Radios";
export const DefaultRadioLabel: string = "Default radio";
export const DefaultCheckedRadio: string = "Default checked radio";
export const ImagesWithCheckboxs: string = "Images with checkbox";
export const ImagesWitRadio: string = "Images with radio";
export const Custom: string = "Custom";
export const CustomRadios: string = "Custom radio";
export const BorderedRadios: string = "Bordered Radio";
export const KohoTheme: string = "Koho Theme";
export const IconsRadios: string = "Icons Radio";
export const FilledRadios: string = "Filled Radio";
export const ProductRadio: string = "Product";
export const DefaultSwitche: string = "Default switches";
export const CustomSwitches: string = "Custom Switches";
export const DefaultSwitchCheckboxInput: string = "Default switch checkbox input";
export const CheckedSwitchCheckboxInput: string = "Checked switch checkbox input";
export const InlineInputType: string = "Inline input-types";
export const InlineCheckbox: string = "Inline Checkbox";
export const InlineRadio: string = "Inline Radios";
export const InlineSwitches: string = "Inline Switches";
export const AnimatedButton: string = "Animated buttons";
export const SelectYourPaymentMethods: string = "Select your payment method";
export const VisaAnimated: string = "Visa";
export const InstagramAnimated: string = "Instagram";
export const WhatIsYourFavoriteSocialMedia: string = "What is your favorite social media?";
export const BasicRadioAndCheckboxs: string = "Basic radio and checkbox";
export const SimpleCheckbox: string = "Simple Checkbox";
export const BasicRadioAndCheckboxBlog: string = "Blog";
export const BasicRadioAndCheckboxSimpleRadios: string = "Simple Radios";
export const BasicRadioAndCheckboxMaps: string = "Maps";
export const RadioToggleButtons: string = "Radio toggle buttons";
export const RadioChecked: string = "Checked";
export const OutlinedCheckboxStyle: string = "Outlined checkbox styles";
export const SingleToggle: string = "Single toggle";
export const ButtonChecked: string = "Checked";
export const ButtonCheckedSuccessRadio: string = "Checked success radio";
export const ButtonDarkRadio: string = "Dark radio";

//Input groups
export const InputGroup: string = "Input groups";
export const ButtonAddon: string = "Button addons";
export const SubmitButtonAddon: string = "Submit";
export const SubmitButtonAddonPlaceHolder: string = "Recipient's username";
export const AddonPlaceHolder: string = "Recipient's username";
export const CustomForm: string = "Custom forms ";
export const OptionsFormGroup: string = "Options";
export const PixelstrapThemeTitle: string = "Select Your Favorite Pixelstrap theme";
export const FavoriteColorsTitle: string = "Select Your Favorite Colors";
export const FavoriteChocolatesTitle: string = "Select Your Favorite Chocolates";
export const FavoriteThemeTitle: string = "Select Your Favorite Theme";
export const CustomFormSubmit: string = "Submit";
export const CustomFileInputs: string = "Custom file input";
export const CustomFileInputsUpload: string = "Upload";
export const CustomFileInputsVerify: string = "Verify";
export const CustomFileInputsSubmit: string = "Submit";
export const ButtonsWithDropdown: string = "Buttons with dropdowns";
export const ButtonsWithDropdownTitle: string = "Dropdown";
export const ToggleDropdown: string = "Toggle Dropdown";
export const SegmentedButton: string = "Segmented buttons";
export const SegmentedButtonInfo: string = "Info";
export const SegmentedButtonSecondary: string = "Secondary";
export const CheckboxesAndRadio: string = "Checkboxes and radios";
export const Sizings: string = "Sizing";
export const SmallInput: string = "Small";
export const DefaultInput: string = "Default";
export const LargeInput: string = "Large";
export const MultipleInput: string = "Multiple inputs";
export const FirstAndLastName: string = "First and last name";
export const BasicInputGroup: string = "Basic input groups";
export const BasicInputGroupBasic: string = "Basic";
export const YourVanityUrl: string = "Your vanity URL";
export const WithTextarea: string = "With textarea";
export const UsernamePlaceholder: string = "Username";
export const RecipientPlaceholder: string = "Recipient's username";
export const ServerPlaceholder: string = "Server";
export const Wrapping: string = "Wrapping";
export const WrappingParagraph: string = "Input groups wrap by default via flex-wrap: wrap in order to accommodate custom form field validation within an input group. You may disable this with ";
export const FlexNowrapCodeText: string = ".flex-nowrap";
export const ButtonBasicInputSubmit: string = "Submit";
export const ButtonBasicInputCancel: string = "Cancel";
export const VariationOfAddon: string = "Variation of addons";
export const LeftAddon: string = "Left Addon";
export const RightAddon: string = "Right Addon";
export const JointAddon: string = "Joint Addon";
export const LeftAddonPlaceholder: string = "Email";
export const RightAddonPlaceholder: string = "Recipient's username";
export const LeftAndRightAddon: string = "Left & Right Addon";
export const SolidStyle: string = "Solid style";
export const FlatStyle: string = "Flat style";
export const RaiseStyle: string = "Raise style";
export const LeftAndRight: string = "Left & Right Addon";
export const VariationOfAddonsSubmit: string = "Submit";
export const VariationOfAddonsCancel: string = "Cancel";

//Mega options
export const MegaOptions: string = "Mega options";
export const VariationRadios: string = "Variation radio";
export const VariationCheckboxs: string = "Variation checkbox";
export const ChooseActivities: string = "Which of the following activities do you enjoy doing in your free time?";
export const UpgradeTitle: string = "It's time to";
export const UpgradeSpanText: string = "upgrade";
export const UpgradeParagraph: string = "Select the theme that best suits your requirements, and you're ready to go!";
export const DefaultStyleMegaOptions: string = "Default style";
export const WithoutBordersStyles: string = "Without borders style";
export const SolidBorderStyles: string = "Solid border style";
export const OfferStyleBorders: string = "Offer style border";
export const InlineStyles: string = "Inline style";
export const VerticalStyles: string = "Vertical style";
export const HorizontalStyles: string = "Horizontal style";

//sample page
export const SamplePage: string = "Sample Page";
export const SampleCard: string = "Sample Card";

//Error Pages
export const BackToHomePage: string = "BACK TO HOME PAGE";
export const Error400Content: string = "The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved.";

//Coming soon
export const WeAreComingSoon: string = "WE ARE COMING SOON";
export const Days: string = "days";
export const Hours: string = "Hours";
export const Minutes: string = "Minutes";
export const Seconds: string = "Seconds";
export const ComingSoonTitle: string = "WE ARE COMING SOON";

//authentication
export const LinkedInIcon: string = " LinkedIn ";
export const TwitterIcon: string = " twitter ";
export const FacebookIcon: string = " facebook ";
export const CreateAccount: string = "Create Account ";
export const DontHaveAccount: string = "Don't have account?";
export const AlreadyHaveAnAccount: string = "Already have an account?";
export const OrSignInWith: string = "Or Sign in with";
export const OrSignUpWith: string = "Or Sign up with";
export const SignInToAccount: string = "Sign in to account";
export const AuthSignIn: string = "Sign in";
export const AuthForgotPassword: string = "Forgot password?";
export const CreateYourAccount: string = "Create your account";
export const CreateYourPassword: string = "Create Your Password";
export const PrivacyPolicy: string = "Privacy Policy";
export const Unlock: string = "Unlock";
export const ResetYourPassword: string = "Reset Your Password";
export const MaintenancesTitle: string = "MAINTENANCE";
export const DoneButton: string = "Done";
export const EnterYourEmailPasswordToLogin: string = "Enter your email & password to login";
export const EnterYourPersonalDetailsToCreateAccount: string = "Enter your personal details to create account";
export const NextWizardButton = "Next";
export const FinishWizardButton = "Finish";
export const PreviousWizardButton = "Previous";
export const EmailAddressLogIn = "Email Address";
export const EmailAddressSignUp = "Email Address";
export const PasswordLogIn = "Password";
export const PasswordSignUp = "Password";
export const RememberPassword = "Remember password";
export const YourNameSignUp = "Your Name";
export const AgreeWithSignUp = "Agree with";
export const SignUpToAccount = "Sign up to account";
export const EnterYourEmailPasswordToLoginWizard = "Enter your email & password to login";
export const EmailAddressWizard = "Email address";
export const EmailAddressWizardPlaceholder = "name@example.com";
export const PasswordWizard = "Password";
export const ConfirmPasswordWizard = "Confirm Password";
export const ConfirmPasswordWizardPlaceholder = "Enter again";
export const PasswordWizardPlaceholder = "Password";
export const FirstNameWizard = "First Name";
export const FirstNameWizardPlaceholder = "Johan";
export const LastNameWizard = "Last Name";
export const LastNameWizardPlaceholder = "Deo";
export const ContactNameWizard = "Contact No.";
export const ContactNameWizardPlaceholder = "123456789";
export const BirthdayWizard = "Birthday:";
export const AgeWizard = "Age";
export const HavePassport = "Have Passport";
export const CountryWizard = "Country";
export const StateWizard = "State";
export const CityWizard = "City";

//Job Search
export const CardsView: string = "Cards View";
export const JobFilterData: string = "Job filter";
export const FilterHeading: string = "Filter";
export const FindJobs: string = "Find jobs";
export const Fulltime: string = "Full-time";
export const SearchPlaceholder: string = "Search..";
export const LocationPlaceholder: string = "location..";
export const Contract: string = "Contract";
export const Parttime: string = "Part-time";
export const Internship: string = "Internship";
export const Temporary: string = "Temporary";
export const Commission: string = "Commission";
export const LocationHeading: string = "Location";
export const AllLocations: string = "All Locations";
export const NewYork: string = "New York";
export const SanFrancisco: string = "San Francisco";
export const Washington: string = "Washington";
export const Seattle: string = "Seattle";
export const Chicago: string = "Chicago";
export const JobHeading: string = "Job";
export const AllJobTitle: string = "All Job Title";
export const UIUxdesigner: string = "UI/Ux designer";
export const GraphicDesigner: string = "Graphic designer";
export const Frontenddesigner: string = "Front end designer";
export const PHPdeveloper: string = "PHP developer";
export const ReactDeveloper: string = "React Developer";
export const IndustryHeading: string = "Industry";
export const AllIndustries: string = "All Industries";
export const ComputerSoftware: string = "Computer Software";
export const ITEngineer: string = "IT Engineer";
export const Serviceindustry: string = "Service industry";
export const Accounting: string = "Accounting";
export const SpecificSkills: string = "Specific skills";
export const AllSkills: string = "All Skills";
export const FinancialServices: string = "Financial Services";
export const htmlcss: string = "HTML,scss & sass";
export const Javascript: string = "Javascript";
export const Nodejs: string = "Node.js";
export const GulpPug: string = "Gulp & Pug";
export const Angularjs: string = "Angular.js";
export const Previous: string = " Previous";
export const Next: string = " Next";
export const ListView: string = "List View";
export const JobDetails: string = "Job Detail";
export const ApplyForThisJob: string = "Apply for this job";
export const ProductDesignerMainCard: string = "Product Designer (UI/UX Designer)";
export const EndLessDesigner: string = "Endless - United States";
export const SimilarJobs: string = "Similar jobs";
export const JobDescriptionHeading: string = "Job Description";
export const Qualifications: string = "Qualifications";
export const AgencyExperience: string = "Agency experience";
export const Perks: string = "Perks";
export const Savethisjob: string = " Save this job";
export const Share: string = "share";
export const JobUIDesigner: string = "UI Designer";
export const JobEndlessTelecomTechnologie: string = "Endless Telecom & Technologies , NY";
export const JobPersonalDetails: string = "Personal Details";
export const JobYourEducation: string = "Your Education";
export const JobYourExperience: string = "Your Experience";
export const JobUploadYourFiles: string = "Upload Your Files";
export const JobSubmitButton: string = "Submit";
export const JobCancelButton: string = "Cancel";
export const FullNameJob: string = "Full name";
export const FullNameJobPlaceholder: string = "Enter your full name";
export const EmailJob: string = "Email";
export const EmailJobPlaceholder: string = "Enter email";
export const PasswordJob: string = "Password";
export const PasswordJobPlaceholder: string = "Enter password";
export const RepeatPasswordJob = "Repeat Password";
export const RepeatPasswordJobPlaceholder = "Repeat password";
export const PhoneNumberJob: string = "Phone Number";
export const PhoneNumberJobPlaceholder: string = "Enter Phone no.";
export const CollegeNameJob: string = "College Name";
export const PeriodJob: string = "Period";
export const DegreeLevelJob: string = "Degree Level";
export const SpecializationJob: string = "Specialization";
export const LocationJob: string = "Location";
export const PositionJob: string = "Position";
export const PositionJobPlaceholder: string = "Enter Position";
export const CompanyNameJob: string = "Company Name";
export const UploadCoverLetterJob: string = "Upload Cover Letter";
export const UploadYourCvJob: string = "Upload Your CV";
export const UploadRecommendationsJob: string = "Upload Recommendations";
export const BirthDateJob: string = "Birth Date";
export const CollagePlaceholder: string = "Enter college name";
export const DegreePlaceholder: string = "Degree";
export const SpecializationPlaceholder: string = "Enter specialization";
export const LocationJobPlaceholder: string = "Enter Location";
export const CompanyJobPlaceholder: string = "Enter Company Name";

//Form Widgets - Datepicker
export const Datepicker: string = "Datepicker";
export const CalendarDefault: string = "Default calendar";
export const CalendarBootstrap: string = "Bootstrap calendar";
export const DatePickers: string = "Date picker";
export const CustomizingConjunction: string = "Customizing Conjunction";
export const DefaultDates: string = "Default Date";
export const DisabledDates: string = "Disabled Dates";
export const HumanFriendly: string = "Human Friendly";
export const MinMaxValue: string = "Min-Max Value";
export const MultiplesDates: string = "Multiples Dates";
export const Range: string = "Range";
export const TimePickerTitle: string = "Time picker";
export const TimePickers: string = "Time Picker";
export const DatePicker: string = "DatePicker";
export const MultiplesDatesHeading: string = "Multiples Dates";
export const RangeDatePicker: string = "Range";
export const PreloadingDates: string = "Preloading Dates";
export const TimPickers: string = "Time picker";
export const TimePickerHeading: string = "Time Picker";
export const hourPicker: string = "24-hour Time Picker";
export const TimePickerLimits: string = "Time Picker W/Limits";
export const PreloadingTime: string = "Preloading Time";
export const TimePickerRange: string = "TimePicker with Limited Time Range";
export const TimePickerMinMaxRange: string = "TimePicker with Min/Max Time Range";
export const DateWithTime: string = "Date With Time";

//Form Widgets - Touchspin
export const Touchspin: string = "Touchspin";
export const DefaultTouchspins: string = "Default touchspin";
export const OutlinedTouchspins: string = "Outlined touchspin";
export const IconsWithPrefixAndPostfixs: string = "Icons with prefix and postfix";
export const ButtonsWithPrefixAndPostfixs: string = "Buttons with prefix and postfix";
export const PreText: string = "Pre";
export const PostText: string = "Post";
export const RoundedTouchspins: string = "Rounded touchspin";

//Form Widgets - Switches
export const Switch: string = "Switch";
export const CustomSwitchs: string = "Custom switch";
export const IconsSwitchs: string = "Icons switch";
export const UncheckedSwitchs: string = "Unchecked switch";
export const BordersWithIcon: string = "Borders with icons";
export const DisabledOutlineSwitchs: string = "Disabled outline switch";
export const VariationOfSwitche: string = "Variation of switches";
export const SwitchSizings: string = "Switch sizing";
export const SwitchWithIcon: string = "Switch with Icons";

//Form Widgets - Clipboard
export const Clipboards: string = "Clipboard";
export const ClipboardTextInput: string = "Clipboard On Text Input";
export const Cutandcopytext: string = "Cut/copy from text input";
export const CutandcopytextPlaceholder: string = "type some text to copy / cut";
export const Copy: string = "Copy";
export const Cut: string = "Cut";
export const ClipboardOnTextareas: string = "Clipboard On Textarea";
export const CutCopyFromTextarea: string = "Cut/copy from textarea";
export const ClipboardOnParagraphs: string = "Clipboard On Paragraph";
export const CopyFromParagraph: string = "Copy From Paragraph";
export const CopyPortionFromParagraphs: string = "Copy Portion From Paragraph";
export const ClipBoardCopy: string = "Copy Portion From Paragraph";
export const HighlightText: string = "Web design is the process of creating websites ";
export const CopyHighLightedText: string = " Copy highlighted text";

//Typeahead
export const Typeahead: string = "Typeahead";
export const BasicTypeaheads: string = "Basic typeahead";
export const statesOfUSA: string = "States of USA";
export const PreFetchHeading: string = "Prefetch";
export const BloodHoundHeading: string = "Bloodhound (Suggestion Engine)";
export const RemotetypeAheadHeading: string = "Remote typeahead";
export const CustomTemplate: string = "Custom templates";
export const MultipleSectionWithHeader: string = "Multiple sections with headers";
export const ScrollableDropDownMenu: string = "Scrollable Dropdown Menu";
export const RTLSupport: string = "RTL Support";

//Bonus Ui - Ribbons
export const Ribbons: string = "Ribbons";
export const VariationsOfLeftRibbons: string = "Variations Of Left Ribbons";
export const VariationsOfRightRibbons: string = "Variations Of Right Ribbons";
export const RibbinLeftTextEm: string = "Ribbon designs";
export const RibbinLeftText1: string = " have been a part of web design. There is a design for you in this collection, regardless of whether you use ";
export const RibbinLeftText2: string = "to identify your items.";
export const CssRibbons: string = "CSS ribbons ";
export const RibbonAndTag: string = "ribbon and tag";
export const RibbonAndTagText: string = " frequently appear together because they have similar features that capture attention and make wonderful spaces for vital information.";

//Paginations
export const Paginations: string = "Paginations";
export const DefaultPaginations: string = "Default Pagination";
export const PaginationWithActiveAndDisabled: string = "Pagination With Active And Disabled";
export const PaginationWithIcon: string = "Pagination With Icons";
export const RoundedPaginations: string = "Rounded Pagination";
export const PaginationAlignments: string = "Pagination Alignment";
export const PaginationSizings: string = "Pagination Sizing";
export const NextData: string[] = ["1", "2", "3", "...", "20"];

//Breadcrumb
export const Breadcrumb: string = "Breadcrumb";
export const Breadcrumbs: string = "Breadcrumb";
export const BreadcrumbHome: string = "Home";
export const BreadcrumbUiKits: string = "Ui Kits";
export const BreadcrumbAlert: string = "Alert";
export const BreadcrumbProgress: string = "Progress";
export const BreadcrumbBonusUi: string = "Bonus Ui";
export const BreadcrumbTable: string = "Table";
export const BreadcrumbBootstrapTable: string = "Bootstrap Tables";
export const DefaultBreadcrumbs: string = "Default Breadcrumb";
export const DividerBreadcrumbs: string = "Divider Breadcrumb";
export const WithIconsBreadcrumbs: string = "With Icons Breadcrumb";
export const VariationOfBreadcrumbs: string = "Variation Of Breadcrumb";
export const ColoredBreadcrumbs: string = "Colored Breadcrumb";

//Bonus Ui - Basic Card
export const BasicCards: string = "Basic Card";
export const FlatCards: string = "Flat Card";
export const WithoutShadowCards: string = "Without shadow Card";
export const BohoTheme: string = "Boho Theme";
export const IconInHeadings: string = "Icon In Heading";
export const DarkColorCards: string = "Dark Color Card";
export const FooterCard: string = "Card Footer";
export const Smarteadphones: string = "Smart headphones";
export const BasicCardText1: string = "Tabs have long been used to show alternative views of the same group of information tabs in software. Known as";
export const BasicCardText2: string = " , these are still used today in web sites. For instance, airline companies such as Ryanair, easyJet and AirMalta use module tabs to enable the user to switch between bookings for flights, hotels and car hire.";
export const DarkColorText1: string = " — also called smart earbuds or hearable — are high-tech in-ear devices that do more than transmit audio. These headphones are usually wireless, and they can sync up with your phone, tablet, computer or other Bluetooth-enabled device. The main appeal of hearables is convenience, as they allow you to complete common tasks without directly accessing your phone or computer. Smart wireless headphones sync up to other devices using Bluetooth technology, and many of their features rely on data from your smartphone or computer.";
export const FlatCardText1: string = "A navigation bar is a particularly important feature because it allows visitors to quickly and easily find";
export const FlatCardTextEm: string = " important pages on your website";
export const FlatCardText2: string = " , like your blog, product pages, pricing, contact info, and documentation. This improves the chances of visitors browsing your site longer, which can boost your page views and reduce your bounce rate.";

//Bonus Ui - Creative Card
export const CreativeCards: string = "Creative Card";
export const BorderLefts: string = "Border Left";
export const BorderRights: string = "Border Right";
export const TopBorder: string = "Border Top";
export const BottomBorder: string = "Border Bottom";
export const TeresaMosteller: string = "Teresa J. Mosteller";
export const GloriaAcheson: string = "Gloria D. Acheson";
export const BryanOwens: string = "Bryan A. Owens";
export const PrimaryBorderState: string = "Border Primary State";
export const WarningBorderState: string = "Border Warning State";
export const SecondaryBorderState: string = "Border Secondary State";
export const AbsoluteCards: string = "Absolute Card";
export const BorderBottomText1: string = "A navigation bar is a particularly important feature because it allows visitors to quickly and easily find";
export const BorderBottomTextEm: string = " important pages on your website";
export const EmailAddressPlaceHolders: string = "youremail@gmail.com";
export const BorderBottomText2: string = " , like your blog, product pages, pricing, contact info, and documentation. This improves the chances of visitors browsing your site longer, which can boost your page views and reduce your bounce rate.";
export const BorderLeftText1: string = "Us Technology offers web & mobile development solutions for all industry verticals.Include a short form using fields that'll help your business understand who's contacting them.";
export const BorderRightText1: string = "Us Technology offers web & mobile development solutions for all industry verticals.Include a short form using fields that'll help your business understand who's contacting them. .";
export const BorderTopText1: string = "Tabs have long been used to show alternative views of the same group of information tabs in software. Known as";
export const BorderTopTextEm: string = "“module tabs”";
export const BorderTopText2: string = " , these are still used today in web sites. For instance, airline companies such as Ryanair, easyJet and AirMalta use module tabs to enable the user to switch between bookings for flights, hotels and car hire.";
export const Timeline: string = "Timeline";
export const BasicTimelines: string = "Basic Timeline";
export const HoveringTimelines: string = "Hovering Timeline";
export const Location: string = "Location";
export const OfwrriorCompanys: string = "Ofwrrior Company";
export const USMeeting: string = "US Meeting";
export const VariationTimelines: string = "Variation Timeline ";
export const UpdatedProduct: string = "Updated Product";
export const HorizontalTimelines: string = "Horizontal Timeline ";
export const ReadMore: string = "Read more";

//Bonus Ui - Timeline
export const ConferanceWithClient: string = "CONFERENCE WITH CLIENT";
export const Conference: string = "Conference";
export const MeetUp: string = "Meet-up";
export const MeetUpTimelineTitle: string = "Meet-up";
export const TimelineTitle: string = "Timeline";
export const FresherInterview: string = "March 2022 - Fresher Interview";
export const AnnualFunction: string = "January 2022- Annual Function";
export const Meetup: string = "December 2022 - Meetup";
export const AppIdeas: string = "app-ideas";
export const EstablishedNewTheAppIdeaRepository: string = "Established new the app-ideas repository.";
export const ViewItOnGithub: string = "View it on Github ";
export const BlogTimelineTitle: string = "Blog";
export const ImplementedTheProgramForWeeklyCodeChallenges: string = "Implemented the program for weekly code challenges.";
export const AudioTesting: string = "Audio testing";
export const MusicalTrendsAndPredictability: string = "Musical trends and predictability";
export const WebDesignersMeeUp: string = "Web-designer's meet-up";
export const PleaseMeetUp: string = "Please! Meet-up";
export const MyResolutions: string = "y Resolutions";
export const MyResolutionsFor2023: string = "My Resolutions for 2023";
export const Resolutions: string = "Resolutions";
export const DesignerTitle: string = "Designer";
export const StaticTimeLineText: string = "At noon today, there will be a meeting with a UK client.";
export const AppIdeaText: string = "developers who are just beginning their learning process. those who often concentrate on developing programmes with a user interface.";
export const BlogTextTime: string = "help you build problem-solving skills, better understand the programming. ";
export const BlogTime: string = "If you want to improve your skills in programming.";
export const CarouselText: string = "Research about most recent design trends.";
export const CarouselSpanText: string = "Spend some time looking up current design trend.";
export const AutoText: string = "So, the next time you listen to music, you might or might not consider how it's actively altering your mood.";
export const MeetUpText: string = "Find nearby web designers to network with! A Web Design Meetup is a place where you can discuss tools.";
export const ResolutionText: string = "I'm determined to streamline, organism, systematism, realign, and embrace life in 2023.";

//Bonus Ui - Sweet Alerts
export const SweetAlert: string = "Sweet Alert";
export const BasicExamples: string = "Basic Example";
export const ClickIt: string = "Click it!";
export const Surprise: string = "Surprise!";
export const TitleWithATextUnder: string = "Title With A Text Under";
export const InfoAlerts: string = "Info Alert";
export const Informational: string = "Informational";
export const WarningAlerts: string = "Warning Alert ";
export const SweetWarningButton: string = "Warning";
export const PikachuAlerts: string = "Pikachu Alert";
export const Pikachu: string = "Pikachu";
export const QuestionsAlerts: string = "Questions Alert ";
export const QuestionsState: string = "Questions state";
export const UsernameAlerts: string = "Username Alert";
export const SuccessMessages: string = "Success Message";
export const LoginSuccessfully: string = "Login successfully";
export const DangerAlerts: string = "Danger Alert ";
export const DangerMode: string = "Danger mode";
export const WarningModes: string = "Warning Mode";
export const AlertMode: string = "Alert mode";
export const Timer: string = "Timer";
export const AjaxRequestMovies: string = "AJAX Request Movie";
export const MovieMode: string = "Movie mode";

//Bonus Ui - Carousel
export const Carousel: string = "Carousel";
export const SlideOnly: string = "Slides Only";
export const WithControl: string = "With Controls";
export const AutoPlayVariants: string = "Auto Play Variant";
export const MouseWheelVariants: string = "Mouse Wheel Variant";
export const WithIndicator: string = "With Indicators";
export const WithCaption: string = "With Captions";
export const CrossFades: string = "Cross-Fade";
export const IndividualCarouselItemIntervals: string = "Individual Carousel-Item Interval";
export const DisableTouchSwipings: string = "Disable Touch Swiping";
export const DarkVariants: string = "Dark Variant";

//Bonus Ui - Range Slider
export const RangeSliders: string = "Range Slider";
export const DefaultRangeSliders: string = "Default Range Slider";
export const MinMaxValues: string = "Min Max Value";
export const NegativeValues: string = "Negative Value";
export const Disable: string = "Disabled";
export const Prefixs: string = "Prefix";
export const FormatedLabels: string = "Formated Label";

//Bonus Ui - Range Slider
export const ImageCropper: string = "Image Cropper";
export const HiddenDownload: string = "Hidden download";
export const DownloadCrop: string = "Download Crop";

//Charts - Apex charts
export const ApexCharts: string = "Apex Chart";
export const BasicAreaCharts: string = "Basic Area Chart ";
export const AreaSpalineCharts: string = "Area Spaline Chart";
export const BarCharts: string = "Bar chart";
export const ColumnCharts: string = "Column Chart ";
export const BubbleCharts: string = "3d Bubble Chart";
export const SteplineCharts: string = "Stepline Chart ";
export const ChartColumn: string = "Column Chart";
export const PieCharts: string = "Pie Chart ";
export const DonutChart: string = "Donut Chart";
export const MixedCharts: string = "Mixed Chart";
export const CandlestickCharts: string = "Candlestick Chart ";
export const RadarCharts: string = "Radar Chart";
export const RadialBarCharts: string = "Radial Bar Chart";

//Charts - Google charts
export const GoogleChart: string = "Google Chart";
export const AreaChartOne: string = "Area Chart 1";
export const ColumnChartOne: string = "Column Chart 1";
export const AreaChartTwo: string = "Area Chart 2";
export const ColumnChartTwo: string = "Column Chart 2";
export const GanttCharts: string = "Gantt Chart";
export const LineCharts: string = "Line Chart";
export const ComboCharts: string = "Combo Chart";
export const BarChartTwo: string = "bar-chart2";
export const WordTreeChart: string = "word tree";
export const PieChartOne: string = "Pie Chart 1";
export const PieChartTwo: string = "Pie Chart 2";
export const PieChartThree: string = "Pie Chart 3";
export const PieChartFour: string = "Pie Chart 4";

//Charts - ChartJS charts
export const ChartJSChart: string = "ChartJS Chart";
export const ChartJSBarChart: string = "Bar Chart";
export const ChatJSLineGraph: string = "Line Graph";
export const ChatJSRadarGraph: string = "Radar Graph";
export const ChatJSLineChart: string = "Line Chart";
export const ChatJSPolarChart: string = "Polar Chart";

//Miscellaneous -  gallery
export const GalleryTitle: string = "Gallery";
export const ImageGallery: string = "IMAGE GALLERY";
export const MyPortfolioTitle: string = "My Portfolio";
export const MasonryGallery: string = "Masonry Gallery";
export const Imagedescription: string = "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";
export const GalleryGridWithDescriptions: string = "Gallery Grid With Description";
export const GalleryGridWithDescriptionCap: string = "IMAGE GALLERY WITH DESCRIPTION";
export const MasonryGalleryWithDescription: string = "Masonry Gallery With Description";
export const MasonryGalleryCap = "MASONRY GALLERY";
export const MasonryGalleryDescriptionCap = "MASONRY GALLERY WITH DESCRIPTIONY";
export const PortfolioTitle = "Portfolio Title";
export const Imagedesc = "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";
export const ImageHoverEffects = "Image Hover Effects";

//Blog - Blog Details
export const BlogDetails: string = "Blog Details";
export const MarkJecnoBlog: string = "People just dont do it anymore. We have to change that. Sometimes the simplest things are the most profound.";
export const MarkJecno: string = "Mark Jecno";
export const Hits: string = "Hits";
export const Comments: string = "Comments";
export const BlogWithoutDetailHeading: string = "Perspiciatis unde omnis iste natus";
export const BlogBy: string = "by:";
export const AdminBlog: string = "Admin";
export const BlogWithDetailHeading: string = "A huge part of it is the incomparable beauty you can encounter every day.";
export const BlogwithoutDetails: string = ` People just don't do it anymore. We have to change that. Sometimes the simplest things are the most profound.`;

//Blog - Blog Single
export const BlogSingle: string = `Blog Single`;
export const SingleBlogParagraph1: string = `Knowledge can be defined as awareness of facts or as practical skills, and may also refer to familiarity with objects or situations. Knowledge of facts, also called propositional knowledge, is often defined as true belief that is distinct from opinion or guesswork by virtue of justification. While there is wide agreement among philosophers that it is a form of true belief, many controversies in philosophy focus on justification: whether it is needed at all, how to understand it, and whether something else besides it is needed.`;
export const SingleBlogParagraph2: string = `Knowledge can be produced in many different ways. The most important source is perception, which refers to the usage of the five senses. Many theorists also include introspection as a source of knowledge, not of external physical objects, but of ones own mental states. Other sources often discussed include memory, rational intuition, inference, and testimony. According to foundationalism, some of these sources are basic in the sense that they can justify beliefs without depending on other mental states. This claim is rejected by coherentists.`;
export const SingleBlogHeading: string = "Knowledge can be defined as awareness of facts or as practical skills. there is wide agreement among philosophers that it is a form of true belief.";
export const JolioMark: string = "Jolio Mark ";
export const SingleBlogParagraph: string = `The best thing is location and drive through the forest. The resort is 35km from Ramnagar. The gardens are well kept and maintained. Its a good place for relaxation away from the city noise. The staff is very friendly and overall we had a really good & fun time, thanks to staff member - Bhairav, Rajat, Gunanand, Lokesh & everyone else. And also we went for an adventurous night safari and saw barking deers, tuskar elephant.`;
export const SingleBlogParagraphs: string = `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`;
export const BlogDesigner: string = "( Designer )";
export const CommentBlog2: string = "From the east coast to the west, each river has its own beauty and character. Each river has its own story. There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.";

//Blog - Add Post
export const AddPost: string = "Add Post";
export const PostEdit: string = "Post Edit";
export const PostTitle: string = "Title";
export const PostTitlePlaceholder: string = "Title";
export const PostCategory: string = "Category";
export const PostType: string = "Type";
export const PostContent: string = "Content";
export const PostTypePlaceholder: string = "Select Your Name....";
export const BlogPostText: string = `Enter text in the area on the left. For more info, click the ? (help) icon in the menu.`;
export const BlogPostButton: string = "Post";
export const BlogDiscardButton: string = "Discard";
export const BlogDropFilesHereOrClickToUpload: string = "Drop files here or click to upload.";

//FAQ
export const Faq = `FAQ`;
export const QuickQuestions: string = "Quick Questions are answered";
export const FeaturedTutorials: string = "Featured Tutorials";
export const Latestarticles: string = "Latest articles and videos";
export const SearchArticles: string = "SearchArticles";
export const SearchArticlesPlaceholder: string = "Search..";
export const Navigation: string = "Navigation";
export const AskQuestion: string = "Ask Question";
export const AskOurCommunity: string = "Ask our community";
export const FaqContactUs: string = "Contact Us";
export const FaqLatestUpdates: string = "Latest Updates";
export const FaqSeeAll: string = "See All";

//Editors
export const CkEditor: string = "Ck Editor";
export const CKEditorExample: string = "CK Editor";
export const InlineEditors: string = "Inline Editor";
export const EditorsText: string = "Your title";
export const MDEEditor: string = "MDE Editor";
export const MdeEditorExample = "MDE Editor Example";
export const SecondExample: string = "Second Example";
export const Instructions = "Instructions";
export const ACECodeEditor = "ACE Code Editor";
export const JavascriptModeTitle = "Javascript Mode";
export const HTMLModeHeading = "HTML Mode";
export const CSSModeHeading = "CSS Mode";
export const JavaModeHeading = "Java Mode";

//Knowledgebase
export const KnowledgebaseHelpQue: string = "How Can I help you?";
export const KnowledgebasePlaceholder: string = "Type question here";
export const knowledgearticle: string = "Browse articles by category";
export const BrowseArticles: string = "Browse Articles";
export const FeaturedTutorial: string = "Featured Tutorials";

//Support Ticket
export const SupportTicket: string = "Support Ticket";
export const SupportTicketList: string = "Support Ticket List";
export const ProfitSupportTicket: string = "Profit";
export const LossSupportTicket: string = "Loss";
export const DeleteSupportTicket: string = "Delete";
export const DeleteData: string = "Delete Selected Data..!";

//Maps
export const GoogleMaps: string = "Google Maps";
export const BasicDemoMap: string = "Basic Demo";
export const CurrentLocation = "Current Location";
export const MarkerMap = "Marker Map";
export const PolygonsTitle: string = "POLYGONS";
export const Polygons: string = "POLYGONS";
export const LeafletMap: string = "Leaflet Map";
export const LeafletWorldMap = "Leaflet WORLD MAP";
export const LeafletUSAMap = "Leaflet USA MAP";
export const LeafletIndiaMap = "Leaflet India MAP";
export const LeafletAustraliaMap = "Leaflet Australia MAP";

//Widgets
export const General: string = "General";
export const TotalUsers: string = "Total Users";
export const WeeklyMonDropdown = ["Weekly", "Monthly", "Yearly"];
export const FollowersGrowth: string = "Followers Growth";
export const Visitors: string = " Visitors";

//Ecommerce - Wishlist
export const MoveToCarts: string = "Move to Cart";
export const InStock: string = "In stock";

//Ecommerce - Pricing
export const Pricing: string = "Pricing";
export const BecomeMembers: string = "Become Member";
export const BecomSignUpeMembers: string = "Sign Up";
export const SignUp: string = "SignUp";
export const SimplePricingCards: string = "Simple Pricing Card";
export const Purchase: string = "Purchase";
export const YourTotalBalance = "768,987.90";

//Project
export const ProjectLists: string = "Project List";
export const All: string = "All";
export const Doing: string = "Doing";
export const Done: string = "Done";
export const CreateNewProject: string = "Create New Project";
export const Issues: string = "Issues";
export const Resolved: string = "Resolved";
export const Comment: string = "Comment";
export const ProjectCreate: string = "Project Create";
export const ProjectTitle = "Project Title";
export const ProjectTitlePlaceholder = "Project name *";
export const ClientName = "Client name";
export const ClientNamePlaceholder = "Name client or company name";
export const ProjectProgress = "Project Progress";
export const ProjectProgressPlaceholder = "Enter project Progress";
export const ProjectStatus = "Project Status";
export const Hourly = "Hourly";
export const FixPrice = "Fix price";
export const Low = "Low";
export const Medium = "Medium";
export const High = "High";
export const Urgent = "Urgent";
export const Priority = "Priority";
export const PriorityPlaceholder = "Select Status";
export const ProjectSize = "Project Size";
export const ProjectSizePlaceholder = "Select Issues";
export const Small = "Small";
export const Big = "Big";
export const StartingDate = "Starting date";
export const EndingDate = "Ending date";
export const ResolvedPlaceholder = "Add Resolved issues";
export const CommentPlaceholder = "Add Comment";
export const EnterSomeDetails = "Enter some Details";
export const Add = "Add";
export const UploadProjectFiles = "Upload project file";
export const DropFileUploadText = "(This is just a demo dropzone. Selected files are ";
export const ActualFileUpload = " actually uploaded.)";

//file manager
export const FileManager = "File Manager";
export const FileFilter: string = "File filter";
export const Storage: string = "Storage";
export const StorageData: string = "25 GB of 100 GB used";
export const PricingPlan: string = "Pricing Plan";
export const TrialVersion: string = "Trial Version";
export const FREE: string = "FREE";
export const PlanSpace: string = "Plan Space";
export const Selected: string = "Selected";
export const Premium: string = "Premium";
export const PricePlan: string = "$5/month";
export const Plan200gb: string = " 200 GB Space";
export const Search: string = "Search...";
export const AddNew: string = "Add New";
export const UploadFile: string = "Upload";
export const Folders = "Folders";
export const Files = "Files";
export const QuickAccessTitle = "Quick Access";

//Email - Application
export const EmailApplications: string = "Email Application";
export const MARKJENCOEMAIL: string = "Markjecno@gmail.com";
export const NewMail: string = "NEW MAIL";
export const MarkJenco: string = "MARKJENCO";
export const EmailFilter: string = "email filter";
export const More: string = "More";
export const Hello: string = "Hello";
export const DearSirGoodMorning: string = "Dear Sir Good Morning,";
export const Elementumvarius: string = "Elementum varius nisi vel tempus. Donec eleifend egestas viverra.";
export const Lorem: string = "Boho Admin is a full featured, multipurpose, premium bootstrap admin template built with Bootstrap 5 Framework, HTML5, CSS and JQuery.It has a huge collection of reusable UI components and integrated with latest jQuery plugins.";
export const Lorem2: string = "It can be used for all type of Web applications like custom admin panel, app backend, CMS or CRM. UI components and integrated with latest jQuery plugins. Boho Admin is a full featured, multipurpose, premium bootstrap admin template built with Bootstrap 5 Framework.";
export const DownloadAll: string = "Download All";
export const Attechments: string = "ATTACHMENTS";

//Email - Email Compose
export const EmailCompose: string = "Email Compose";
export const NewMessage = "New Message";
export const To = "To";
export const Subject = "Subject";
export const Send = "Send";
export const Message = "Message";

//Chat
export const ChatApp: string = "Chat App";
export const ChatStatus = "Status...";
export const Typing = "Typing...";
export const chatMenuNavData: string[] = ["CALL", "STATUS", "PROFILE"];
export const MARKJENCO = "MARK JENCO";
export const Follower = "Follower";
export const Fax = "Fax";

//Video Chat
export const VideoChat = "Video Chat";
export const UserType = "Typing...";
export const LastSeen = "Last Seen";
export const EndCall = "END CALL";
export const Chart: string = "Chart";
export const TotalSaleHeading: string = "Total Sale";
export const CompareLastMonth: string = "Compare to last month";
export const TotalProjectHeading: string = "Total Project";
export const TotalProductHeading: string = "Total Product";
export const MonthlyHistoryHeading: string = "Monthly  History";
export const SkillStatusHeading: string = "Skill Status";
export const OrderStatusHeading: string = "Order Status";
export const LiveProductsHeading: string = "Live Products";
export const TurnOverHeading: string = "Turn over";
export const CryptocurrencyPricesHeading: string = "Cryptocurrency Prices";
export const CryptoAnnotationsHeading: string = "Crypto Annotations";
export const StockMarketHeading: string = "Stock Market";
export const FinanceHeading: string = "Finance";
export const MonthlySalesHeading: string = "Monthly Sales";
export const UsesHeading: string = "Uses";

//Dashboard
export const DefaultDashboard: string = "Default Dashboard";
export const GoodMorning: string = "Good Morning";
export const WadeWarren: string = " Wade Warren";
export const AddProducts: string = "Add Product";
export const YourCurrentBalances: string = "Your Current Balance";
export const SentAmount: string = "Sent amount";
export const Transfer: string = "Transfer";
export const Receive: string = "Receive";
export const WeeklyVisitor: string = "Weekly Visitors";
export const TrackOrders: string = "Track Order";
export const OldReisTelephone: string = "Old Reis Telephone";
export const BestSellingProduct = "Best Selling Product";

//Ecommerce - Dashboard
export const Dashboards: string = "Dashboard";
export const EcommerceDashboard: string = "Ecommerce Dashboard";
export const Earnings: string = "Earning";
export const TransactionHistorys = "Transaction History";
export const AuditLogs = "Audit log ";
export const UserInformations = "User Information";
export const SalesSummarys = "Sales Summary";
export const Traffics = "Traffic";
export const Edit: string = "Edit";
export const Delete: string = "Delete";
export const NewsUpdate: string = "News & Update";
export const OverAllRatings: string = "Over All Rating";
export const ManageOrders: string = "Manage Order";
export const ScheduleALesson: string = "Schedule a lesson";

//Page Layout
export const DarkFooter: string = "Footer Dark";
export const FixedFooter: string = "Footer Fixed";
export const OnScrollHideMenu: string = "Hide Menu On Scroll";
export const SampleCardText: string = "lorem ipsum dolor sit amet, consectetur adipisicing elit";

//Ecommerce - Product
export const Product: string = "Product";
export const Filters: string = "Filters";
export const ProductShown: string = "Showing Products 1 - 24 Of 200 Results";
export const Featured: string = "Featured";
export const LowestPrices: string = "Lowest Prices";
export const HighestPrices: string = "Highest Prices";
export const Categorys: string = "Category";
export const WomanTshirt: string = "Woman T-shirt";
export const DreamBeautyFashion: string = "Dream Beauty Fashion";
export const WomensDress: string = "Womens's Dress";
export const Cyclamen: string = "Cyclamen";
export const ManTshirt: string = "Man's T-shirt";
export const Levis: string = "Levi's";
export const Diesel: string = "Diesel";
export const Lee: string = "Lee";
export const Hudson: string = "Hudson";
export const Denizen: string = "Denizen";
export const Spykar: string = "Spykar";
export const Colors: string = "Colors";
export const Price: string = "Price";
export const STEP: number = 10;
export const MIN: number = 10;
export const MAX: number = 1250;
export const NewProducts: string = "New Products";
export const ModalWomanText: string = "Lorate Solid Men's Fashion Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra Denim Jacket.";
export const ModalMensText: string = "Lorate Solid Men's Fashion Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra Denim Jacket.";
export const ModalLongText: string = "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.";
export const ModalRavaiyaaText: string = "Ravaiyaa - Attitude is everything Cotton Men's Dresses One Top Button T-Shirt.";
export const ModalRockText: string = "Rock Paper Scissors women's Tank Top High Neck Cotton Top Stylish Women Top..";
export const ProductSizeArray: string[] = ["M", "L", "Xl"];
export const ProductDetails: string = "Product Details";
export const Quantity: string = "Quantity";
export const AddToCartity: string = "Add to Cart";
export const ViewDetails: string = "View Details";

//Ecommerce - Cart
export const Cart: string = "Cart";
export const CartTableHeader = ["Product", "Prdouct Name", "Price", "Quantity", "Action", "Total"];
export const CartEmpty = "Cart Empty";
export const ExploreShortlistItems = "Explore Short list Items";
export const Apply = "Apply";
export const TotalPrice = "Total Price";
export const ContinueShopping = "continue shopping";
export const CheckOut = " check out";

//To Do
export const ToDoHeading: string = "To-Do";
export const ToDoFilter: string = "To Do filter";
export const ToDoList: string = "To Do List";
export const ToDoPlaceholder: string = "Enter new task here. . .";
export const AllTask: string = "All Task";
export const TrashBin: string = "Trash";
export const Completed: string = "Completed";
export const Pending: string = "Pending";
export const InProcess: string = "In Process";

//Search
export const SearchWebsite: string = "Search Website";
export const SearchPages: string = "Search Pages";
export const SearchPixelStrap: string = `Search result for "Pixelstrap"`;
export const SearchDesc = "Accusamus et iusto odio dignissimos ducimus qui blanditiis.";
export const ImageAbout: string = "About 12,120 results (0.50 seconds)";
export const AllAbout: string = `About 6,000 results (0.60 seconds)`;

//From Layout - wizard 2
export const StepFormWizard: string = "Step Form Wizard";
export const Continue: string = "Continue";
export const AadhaarNumber: string = "Aadhaar Number";
export const PAN: string = "PAN";
export const ChooseBanks: string = "Choose from these popular banks";
export const DescribeYourIssue: string = "If no, could you please describe?";
export const SuccessfullyCompleted: string = "Successfully Completed";
export const AccountType: string = "Select the type of account";
export const AccountName: string = "Account Name";
export const SelectTeamWith: string = "Select team size with";
export const Projects: string = "projects";
export const ContactDetails: string = "Contact details";
export const OrganizationName: string = "Organization Name";
export const JoinOrganizationType: string = "Join organization type";
export const OrganizationDescription: string = "Organization description";
export const CardHolder: string = "Card Holder";
export const PanPlaceholder: string = "xxxxxxxxxx";
export const InqMail: string = "org@support.com";
export const ShareYourProblemsAndAnotherIssues: string = "Share your problems and another issues";
export const GekkoCo: string = "Gekko & Co.";

//Form layout - Two factor
export const TwoFactorHeading: string = "Two Factor";
export const TwoFactorAuthenticationHeading: string = "Two-factor authentication";
export const FactorAuthentication: string = "2 factor authentication";
export const VerificationCodeHeading: string = "Verification code";
export const OtpCodeSent: string = "We've sent a verification code to";
export const OtpCode: string = "Your OTP Code here:";
export const Verify: string = "Verify";
export const Resend: string = "Resend";
export const Call: string = " Call";
export const ModalTitle: string = "Modal title";
export const ScanQRCode: string = "Scan QR code";
export const EmailVerificationHeading: string = "Email verification";
export const EnterQRCode: string = "Enter QR Code";
export const PleaseEnterTheCodeHere: string = "Please enter the code here";

//From Layout - wizard 1
export const FormWizard: string = "Form Wizard";
export const NumberingWizardHeading: string = "Numbering wizard";
export const ConfirmPassword: string = "Confirm Password";
export const AgreeToTermsAndConditions: string = "Agree to terms and conditions";
export const PlaceHolderName: string = "Placeholder Name";
export const CardNumber: string = "Card Number";
export const Expiration: string = "Expiration(MM/YY)";
export const CVVNumber: string = "CVV Number";
export const UploadDocumentation: string = "Upload Documentation";
export const AboveInformationCorrect: string = "All the above information is correct";
export const LinkedIn: string = "LinkedIn";
export const Github: string = "Git hub";
export const SelectState: string = "Select State";
export const GiveFeedback: string = "Give Feedback";
export const Congratulations: string = "Congratulations ";
export const StudentValidationFormHeading: string = "Student validation form";
export const Name = "Name";
export const AddProfile: string = "Add Profile";
export const PortfolioURL: string = " Portfolio URL";
export const ProjectDescription: string = " Project Description";
export const SocialLinks: string = " Social Links ";
export const Twitter: string = " Twitter";
export const VerticalValidationWizardHeading: string = "Vertical validation wizard";
export const SelectPaymentMethod: string = "Select your payment method";
export const NetBanking: string = " NET BANKING";
export const SelectYourBank: string = " SELECT YOUR BANK";
export const AgreeConditions: string = "Agree to terms and conditions";
export const Finish: string = "Finish";
export const ShippingFormHeading: string = "Shipping form";
export const BillingInformation: string = "Billing Information ";
export const FillFollowingInformation: string = "Fill up the following information ";
export const ShippingInformation: string = "Shipping Information";
export const SavedAddress: string = "Saved Address";
export const Information: string = "Information";
export const ShippingMethod: string = "Shipping Method";
export const ProceedNext: string = "Proceed to Next";
export const PaymentInformation: string = "Payment Information";
export const CreditCard: string = "Credit Card";
export const CashOnDeliveryHeading: string = "Cash On Delivery";
export const OrderConfirmed: string = "Thank you! Your order is confirmed.";
export const OrderID: string = "Order ID";
export const CurrentCartHeading: string = "Current Cart";
export const EnterYourName: string = "Enter your name";
export const EnterPassword: string = "Enter password";
export const EnterConfirmPassword: string = "Enter confirm password";
export const PlaceholderName: string = "Placeholder name";
export const ExpiryPlaceholder: string = "xx/xx";
export const LinkedInPlaceholder: string = "https://linkedIn.com/hoho";
export const GitHubPlaceholder: string = "https://github.com/boho";
export const TwitterPlaceholder: string = "https://twitter.com/boho";
export const AllTheAboveInformationIsCorrect: string = "All the above information is correct";
export const Address: string = "Address";
export const RememberMeForNextTime: string = "Remember me for next time";
export const OtherNotes: string = "Other notes";
export const EnterYourQueries: string = "Enter your queries...";
export const ProceedToNext: string = "Proceed to next";
export const BohoMail: string = "boho@example.com";
export const AdharPlaceholder: string = "xxxx xxxx xxxx xxxx";
export const ZipCode: string = "Zip Code";
export const ContactNumber: string = "Contact Number";
export const EnterFirstName: string = "Enter first name";
export const EnterLastName: string = "Enter last name";
export const EnterNumber: string = "Enter number";

//Tasks
export const Tasks = "Tasks";
export const TaskFilter = "Task filter";
export const NewTask = "New Task";
export const AddTask: string = "Add Task";
export const TaskTitle = "Task Title";
export const Collection: string = "Collection";
export const SubTask: string = "Sub task";
export const RemindOn: string = "Remind on";
export const Notification: string = "Notification";
export const Mail: string = "Mail";
export const TagColor: string = "Tag color";
export const CreateTags: string = "Create Tag";
export const TagName: string = "Tag Name";
export const CreatedByMe: string = "Created By Me";
export const TodayTasks: string = "Today Tasks";
export const DelayedTasks: string = "Delayed Tasks";
export const UpcomingTasks: string = "Upcoming Tasks";
export const ThisWeekTask: string = "This Week Task";
export const ThisMonthTasks: string = "This Month Task";
export const AssignedToMe: string = "Assigned To Me";
export const MyTasks: string = "My Tasks";
export const Newsletter: string = "Newsletter";

//Calendar
export const CalendarBasic: string = "Calender Basic";
export const DraggableEvents = "Draggable Events";
export const RemoveAfterDrop = "remove after drop";
export const CalendarFilter = "calendar filter";
//Social App
export const SocialApp = "Social App";
export const MyProfile = "My Profile";
export const MyPage = "My Page";
export const Likes = "Likes";
export const View: string = "View";
export const MutualFriend = "Mutual Friends";
export const ActivityFeed: string = "Activity Feed";
export const ELANAHeading = "ELANA";
export const MoreCommnets = "More Commnets";
export const CommentsSocialPlaceholder = "Post Your commnets";
export const ProfileIntro = "Profile Intro";
export const Facebook = "Facebook";
export const Dribbble = "Dribbble";
export const AddFriend = "Add Friend";
export const LatestPhoto = "Latest Photos";
export const Friends = "Friends";
export const PepoleKnow = "Pepole You May Know";
export const EducationAndEmploymentHeading = "Education and Employement";
export const HobbiesAndInterest = "Hobbies and Interests";
export const ActivityLogHeading = "Activity Log";

//Ecommerce - Product page
export const ProductPage: string = "Product Page";
export const ProductTittle: string = "Women Pink shirt.";
export const ProductDetail: string = "Rock Paper Scissors Various Dots Half Sleeves Girl’s Regular Fit T-Shirt I 100% Cotton T Shirt with Half Sleeve Round Neck I Regular Wear Solid Kids Tees and Black Sleeve.";
export const Pixelstrap: string = "Pixelstrap";
export const Availability: string = "Availability";
export const Instock: string = "In stock";
export const Seller: string = "Seller";
export const ABC: string = "ABC";
export const Fabric: string = "Fabric";
export const Cotton: string = "Cotton";
export const ShareIt: string = "share it";
export const RateNow: string = "Rate Now";
export const ProductReview: string = "(250 review)";
export const AddToCart: string = "Add To Cart";
export const BuyNow: string = "Buy Now";
export const AddToWishList: string = "Add To WishList";
export const Brands: string[] = ["Clothing", "Bags", "Footwear", "Watches", "ACCESSORIES"];
export const ClothsDetailsData: string[] = ["Febric", "Video", "Details", "Brand"];
export const Discription1 = "Refresh your wardrobe with this chic top. With an eye-catching square neck, this top also features pretty puff sleeves. Stunning pink colour Classic solid pattern Square neck Elasticated puff sleeves Belt included, Polyester fabric, machine wash..";
export const Discription2 = "Tee Stores is an Indian contemporary clothing brand. The product pages display a fine quality fabric with colorful description. We offer many vivid designs, art, styles that combine heritage with modernity, simplicity, playfulness and street style";
export const Discription3 = "Lorate Solid Men's Fashion Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra Denim Jacket.";
export const Discription4 = "Rock Paper Scissors Various Dots Half Sleeves Girl’s Regular Fit T-Shirt I 100% Cotton T Shirt with Half Sleeve Round Neck I Regular Wear Solid Kids Tees and Black Sleeve.";

//Ecommerce - Product List
export const ProductList: string = "Product list";
export const ProductListTitle: string = "Individual column searching (text inputs)";
export const ProductListText: string = "The searching functionality provided by DataTables is useful for quickly search through the information in the table - however the search is global, and you may wish to present controls that search on specific columns.";

//Ecommerce - Payment Details
export const PaymentDetails: string = "Payment Details";
export const CreditSelect: string[] = ["Select Type", "Master", "Visa"];
export const CreditCards: string = "Credit Card";
export const DebitCards: string = "Debit Card";
export const ExpirationDate: string = "Expiration Date";
export const DebitMonthSelect: string[] = ["Select Month", "Jan", "Fab", "March", "April"];
export const DebitYearSelect: string[] = ["Select Year", "2015", "2016", "2017", "2023", "2019"];
export const Cod: string = "COD";
export const Emi: string = "EMI";
export const EmiBankSelect: string[] = ["Bank Name", "SBI", "ICICI", "KOTAK", "BOB"];
export const EmiCardSelect: string[] = ["Select Card", "2", "3", "4", "5"];
export const EmiYearSelect: string[] = ["Select Duration", "2015-2016", "2016-2017", "2017-2023", "2023-2019"];
export const NetBankings: string = "Net Banking";

//Ecommerce - Recent Orders
export const RecentOrders: string = "Recent Orders";
export const NewOrder: string = "New Orders";
export const Processing: string = "Processing";
export const Shipped: string = "Shipped";
export const ShippedOrder: string = "Shipped Orders";
export const CancelledOrder: string = "Cancelled Orders";
export const Cancelled: string = "Cancelled";
export const OrdersHistorys = "Orders History";

//Ecommerce - Checkout
export const BillingDetails: string = "Billing Details";
export const CountryMenu: string[] = ["India", "South Africa", "United State", "Australia"];
export const TownCity: string = "Town City";
export const StateCountry: string = "State Country";
export const PostalCode: string = "Postal Code";
export const PlaceOrder: string = "Place Order";
export const FirstNameRequired: string = "First name is required";
export const LastNameRequired: string = "Last name is required";
export const PhoneRequired: string = "Please enter number for phone";
export const EmailRequired: string = "Please enter proper email address";
export const AddressRequired: string = "Please right your address";
export const CityRequired: string = "select one city";
export const StateRequired: string = "select one state";
export const PincodeRequired: string = "Required integer";
export const CheckoutRequired: string = "Need to mark";
export const Total: string = "Total";
export const Subtotal: string = "Subtotal";
export const Shipping: string = "Shipping";
export const Option1: string = "Option 1";
export const Option2: string = "Option 2";
export const CheckPayments: string = "Check Payments";
export const CashOnDelivery: string = "Cash On Delivery";
export const PayPal: string = "PayPal";

//Ecommerce - Invoice
export const Invoice: string = "Invoice";
export const InvoiceHash = "Invoice #";
export const Boho = "Boho";
export const ProductDescription = "Project Description";
export const Print = "Print";

//Contacts
export const ContactTitle: string = "Contacts";
export const ContactFilter: string = "contact filter";
export const NewContacts: string = "New Contacts";
export const AddContacts: string = " Add Contact";
export const Phone: string = "Phone";
export const Mobile: string = "Mobile";
export const AddCategory: string = "Add Category";
export const Personal: string = "Personal";
export const MobileNo = "Mobile No";
export const History = "History";
export const PrintViews = "Print preview";
export const Gender = "Gender";
export const FollowUp = "Follow up";
export const Ideas = "Ideas";
export const ContactHistory = "Contact History";
export const ContactCreated = "Contact Created";

//User
export const UserProfile: string = "User Profile";
export const Like: string = "Like";
export const EditProfile: string = "Edit Profile";
export const MyProfiles: string = "My Profile";
export const Designer: string = "DESIGNER";
export const Bio: string = "Bio";
export const Password: string = "Password";
export const Save: string = "Save";
export const Website: string = "Website";
export const WebPlaceHolders: string = "http://Uplor.com";
export const Country = "Country";
export const AboutMe = "About Me";
export const UpdateProfile: string = "UpdateProfile";
export const AddprojectAndUpload: string = "Add project And Upload";
export const Update: string = "Update";
export const UserCards: string = "User Cards";
export const Followers = "Followers";
export const Following: string = "Following";

//Bookmarks
export const Bookmarks: string = "Bookmarks";
export const BookmarkFilter: string = "Bookmark filter";
export const NewBookmark: string = "New Bookmark";
export const AddBookmark: string = "Add Bookmark";
export const WebUrl = "Web Url";
export const Title = "Title";
export const Group = "Group";
export const Views = "Views";
export const Tags = "Tags";
export const CreateTag = "Create Tag";
export const NoBookmarksFound = "No Bookmarks Found.";
export const Favourites = "Favourites";
export const SharedWithMe = "Shared with me";
export const Holidays = "Holidays";
export const Important = "Important";
export const Orgenization = "Organization";
export const MyBookmark = " My bookmark";
export const EditBookmark = "Edit Bookmark";
export const MyBookmarks = "My Bookmarks";

//Theme Customizer
export const PreviewsSettings: string = "PREVIEW SETTINGS";
export const TryItRealTime: string = "Try It Real Time";
export const LayoutTypes: string = "Layout Type";
export const SidebaType: string = "Sidebar Type";
export const SidebarIcon: string = "Sidebar Icon";
export const UnlimitedColor: string = "Unlimited Color";
export const MixLayout: string = "MixLayout";
export const Configuration = "Configuration";
